// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/cal-card.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/first.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/mobile/mobile_landing.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../assets/second.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../assets/mobile/mobile_pension.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../assets/third.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../assets/mobile/mobile_welfare.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../assets/about_us.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../assets/fourth.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../assets/mobile/mobile_loan.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../assets/cloud-arrow-up.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../assets/box_border.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,900;1,100;1,700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.2.1 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: currentColor; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
*/

html {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font family by default.
2. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none {
  pointer-events: none;
}
.visible {
  visibility: visible;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.inset-0 {
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
}
.inset-y-0 {
  top: 0px;
  bottom: 0px;
}
.right-0 {
  right: 0px;
}
.left-0 {
  left: 0px;
}
.top-10 {
  top: 2.5rem;
}
.z-10 {
  z-index: 10;
}
.z-50 {
  z-index: 50;
}
.order-2 {
  order: 2;
}
.order-1 {
  order: 1;
}
.col-span-2 {
  grid-column: span 2 / span 2;
}
.m-auto {
  margin: auto;
}
.m-2 {
  margin: 0.5rem;
}
.m-0 {
  margin: 0px;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-8 {
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-8 {
  margin-top: 2rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mt-16 {
  margin-top: 4rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.ml-4 {
  margin-left: 1rem;
}
.mr-4 {
  margin-right: 1rem;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mt-24 {
  margin-top: 6rem;
}
.mt-32 {
  margin-top: 8rem;
}
.mt-12 {
  margin-top: 3rem;
}
.mb-12 {
  margin-bottom: 3rem;
}
.ml-8 {
  margin-left: 2rem;
}
.mb-0 {
  margin-bottom: 0px;
}
.mb-32 {
  margin-bottom: 8rem;
}
.mt-28 {
  margin-top: 7rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.mt-auto {
  margin-top: auto;
}
.mt-52 {
  margin-top: 13rem;
}
.mt-20 {
  margin-top: 5rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.ml-3 {
  margin-left: 0.75rem;
}
.mb-28 {
  margin-bottom: 7rem;
}
.ml-12 {
  margin-left: 3rem;
}
.mr-40 {
  margin-right: 10rem;
}
.ml-32 {
  margin-left: 8rem;
}
.mt-\\[30px\\] {
  margin-top: 30px;
}
.mt-\\[60px\\] {
  margin-top: 60px;
}
.mt-\\[10px\\] {
  margin-top: 10px;
}
.mt-\\[40px\\] {
  margin-top: 40px;
}
.mt-\\[70px\\] {
  margin-top: 70px;
}
.mt-\\[20px\\] {
  margin-top: 20px;
}
.block {
  display: block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.grid {
  display: grid;
}
.contents {
  display: contents;
}
.hidden {
  display: none;
}
.h-5 {
  height: 1.25rem;
}
.h-3 {
  height: 0.75rem;
}
.h-full {
  height: 100%;
}
.h-screen {
  height: 100vh;
}
.h-28 {
  height: 7rem;
}
.h-24 {
  height: 6rem;
}
.h-16 {
  height: 4rem;
}
.h-9 {
  height: 2.25rem;
}
.h-12 {
  height: 3rem;
}
.h-7 {
  height: 1.75rem;
}
.h-\\[90\\%\\] {
  height: 90%;
}
.h-14 {
  height: 3.5rem;
}
.h-6 {
  height: 1.5rem;
}
.h-px {
  height: 1px;
}
.h-\\[74px\\] {
  height: 74px;
}
.h-\\[392px\\] {
  height: 392px;
}
.h-\\[fit-content\\] {
  height: -moz-fit-content;
  height: fit-content;
}
.h-\\[20px\\] {
  height: 20px;
}
.h-\\[1px\\] {
  height: 1px;
}
.h-\\[32px\\] {
  height: 32px;
}
.h-\\[177px\\] {
  height: 177px;
}
.h-\\[109px\\] {
  height: 109px;
}
.max-h-60 {
  max-height: 15rem;
}
.w-5 {
  width: 1.25rem;
}
.w-full {
  width: 100%;
}
.w-64 {
  width: 16rem;
}
.w-3 {
  width: 0.75rem;
}
.w-8 {
  width: 2rem;
}
.w-16 {
  width: 4rem;
}
.w-12 {
  width: 3rem;
}
.w-28 {
  width: 7rem;
}
.w-9 {
  width: 2.25rem;
}
.w-40 {
  width: 10rem;
}
.w-7 {
  width: 1.75rem;
}
.w-96 {
  width: 24rem;
}
.w-fit {
  width: -moz-fit-content;
  width: fit-content;
}
.w-\\[80\\%\\] {
  width: 80%;
}
.w-screen {
  width: 100vw;
}
.w-6 {
  width: 1.5rem;
}
.w-11\\/12 {
  width: 91.666667%;
}
.w-9\\/12 {
  width: 75%;
}
.w-4\\/5 {
  width: 80%;
}
.w-10\\/12 {
  width: 83.333333%;
}
.w-14 {
  width: 3.5rem;
}
.w-\\[100\\%\\] {
  width: 100%;
}
.w-\\[35\\%\\] {
  width: 35%;
}
.w-\\[90\\%\\] {
  width: 90%;
}
.w-\\[20px\\] {
  width: 20px;
}
.w-\\[61px\\] {
  width: 61px;
}
.w-\\[148px\\] {
  width: 148px;
}
.w-\\[440px\\] {
  width: 440px;
}
.w-\\[370px\\] {
  width: 370px;
}
.w-\\[168px\\] {
  width: 168px;
}
.w-\\[310px\\] {
  width: 310px;
}
.w-\\[330px\\] {
  width: 330px;
}
.w-\\[340px\\] {
  width: 340px;
}
.w-\\[208px\\] {
  width: 208px;
}
.w-\\[234px\\] {
  width: 234px;
}
.w-\\[485px\\] {
  width: 485px;
}
.w-\\[2px\\] {
  width: 2px;
}
.w-\\[438px\\] {
  width: 438px;
}
.w-\\[384px\\] {
  width: 384px;
}
.w-\\[300px\\] {
  width: 300px;
}
.w-\\[400px\\] {
  width: 400px;
}
.w-\\[500px\\] {
  width: 500px;
}
.w-\\[228px\\] {
  width: 228px;
}
.w-\\[114px\\] {
  width: 114px;
}
.w-\\[184px\\] {
  width: 184px;
}
.w-\\[230px\\] {
  width: 230px;
}
.w-\\[580px\\] {
  width: 580px;
}
.w-\\[65\\%\\] {
  width: 65%;
}
.max-w-7xl {
  max-width: 80rem;
}
.max-w-full {
  max-width: 100%;
}
.max-w-screen-lg {
  max-width: 1024px;
}
.flex-1 {
  flex: 1 1;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.grow {
  flex-grow: 1;
}
.scale-0 {
  --tw-scale-x: 0;
  --tw-scale-y: 0;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.cursor-default {
  cursor: default;
}
.cursor-pointer {
  cursor: pointer;
}
.select-none {
  -webkit-user-select: none;
          user-select: none;
}
.grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-5 {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.flex-row {
  flex-direction: row;
}
.flex-col {
  flex-direction: column;
}
.place-items-start {
  place-items: start;
}
.place-items-center {
  place-items: center;
}
.items-start {
  align-items: flex-start;
}
.items-center {
  align-items: center;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-around {
  justify-content: space-around;
}
.justify-items-end {
  justify-items: end;
}
.justify-items-center {
  justify-items: center;
}
.gap-4 {
  gap: 1rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-x-8 {
  column-gap: 2rem;
}
.space-x-20 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(5rem * var(--tw-space-x-reverse));
  margin-left: calc(5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-11 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(2.75rem * var(--tw-space-x-reverse));
  margin-left: calc(2.75rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-8 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(2rem * var(--tw-space-x-reverse));
  margin-left: calc(2rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-7 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1.75rem * var(--tw-space-x-reverse));
  margin-left: calc(1.75rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-7 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.75rem * var(--tw-space-y-reverse));
}
.space-x-5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1.25rem * var(--tw-space-x-reverse));
  margin-left: calc(1.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-20 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(5rem * var(--tw-space-y-reverse));
}
.space-x-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-12 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(3rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(3rem * var(--tw-space-y-reverse));
}
.space-x-9 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(2.25rem * var(--tw-space-x-reverse));
  margin-left: calc(2.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-x-52 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(13rem * var(--tw-space-x-reverse));
  margin-left: calc(13rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-9 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(2.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2.25rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-x-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.75rem * var(--tw-space-x-reverse));
  margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.overflow-auto {
  overflow: auto;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-sm {
  border-radius: 0.125rem;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-\\[64px\\] {
  border-radius: 64px;
}
.border {
  border-width: 1px;
}
.border-2 {
  border-width: 2px;
}
.border-\\[1px\\] {
  border-width: 1px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-solid {
  border-style: solid;
}
.border-\\[\\#F24A4A\\] {
  --tw-border-opacity: 1;
  border-color: rgb(242 74 74 / var(--tw-border-opacity));
}
.border-\\[\\#133B69\\] {
  --tw-border-opacity: 1;
  border-color: rgb(19 59 105 / var(--tw-border-opacity));
}
.border-\\[\\#D1DAE5\\] {
  --tw-border-opacity: 1;
  border-color: rgb(209 218 229 / var(--tw-border-opacity));
}
.border-\\[\\#04825F\\] {
  --tw-border-opacity: 1;
  border-color: rgb(4 130 95 / var(--tw-border-opacity));
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-default-blue {
  --tw-bg-opacity: 1;
  background-color: rgb(19 59 105 / var(--tw-bg-opacity));
}
.bg-black\\/30 {
  background-color: rgb(0 0 0 / 0.3);
}
.bg-\\[\\#F8F8F8\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(248 248 248 / var(--tw-bg-opacity));
}
.bg-default-banner {
  background-color: #f0f8ffd1;
}
.bg-\\[\\#ECF4FF42\\] {
  background-color: #ECF4FF42;
}
.bg-\\[\\#D1DAE5\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(209 218 229 / var(--tw-bg-opacity));
}
.bg-\\[\\#04825F\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(4 130 95 / var(--tw-bg-opacity));
}
.bg-clip-padding {
  background-clip: padding-box;
}
.object-contain {
  object-fit: contain;
}
.object-bottom {
  object-position: bottom;
}
.p-4 {
  padding: 1rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-8 {
  padding: 2rem;
}
.p-12 {
  padding: 3rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-6 {
  padding: 1.5rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-7 {
  padding-top: 1.75rem;
  padding-bottom: 1.75rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.px-12 {
  padding-left: 3rem;
  padding-right: 3rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.pr-9 {
  padding-right: 2.25rem;
}
.pr-2 {
  padding-right: 0.5rem;
}
.pl-10 {
  padding-left: 2.5rem;
}
.pr-4 {
  padding-right: 1rem;
}
.pl-3 {
  padding-left: 0.75rem;
}
.pl-4 {
  padding-left: 1rem;
}
.pl-8 {
  padding-left: 2rem;
}
.pt-5 {
  padding-top: 1.25rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pr-10 {
  padding-right: 2.5rem;
}
.pl-6 {
  padding-left: 1.5rem;
}
.pl-5 {
  padding-left: 1.25rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pb-3 {
  padding-bottom: 0.75rem;
}
.pl-0 {
  padding-left: 0px;
}
.pr-0 {
  padding-right: 0px;
}
.pt-\\[100px\\] {
  padding-top: 100px;
}
.pt-\\[10px\\] {
  padding-top: 10px;
}
.pb-8 {
  padding-bottom: 2rem;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-\\[20px\\] {
  font-size: 20px;
}
.text-\\[24px\\] {
  font-size: 24px;
}
.font-medium {
  font-weight: 500;
}
.font-semibold {
  font-weight: 600;
}
.font-normal {
  font-weight: 400;
}
.font-light {
  font-weight: 300;
}
.uppercase {
  text-transform: uppercase;
}
.leading-normal {
  line-height: 1.5;
}
.leading-3 {
  line-height: .75rem;
}
.leading-relaxed {
  line-height: 1.625;
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.text-default-blue {
  --tw-text-opacity: 1;
  color: rgb(19 59 105 / var(--tw-text-opacity));
}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.text-default-gray {
  --tw-text-opacity: 1;
  color: rgb(128 128 128 / var(--tw-text-opacity));
}
.text-\\[\\#F24A4A\\] {
  --tw-text-opacity: 1;
  color: rgb(242 74 74 / var(--tw-text-opacity));
}
.text-\\[\\#000\\] {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.text-\\[\\#133B69\\] {
  --tw-text-opacity: 1;
  color: rgb(19 59 105 / var(--tw-text-opacity));
}
.text-\\[\\#696969\\] {
  --tw-text-opacity: 1;
  color: rgb(105 105 105 / var(--tw-text-opacity));
}
.text-\\[\\#1E1E1E\\] {
  --tw-text-opacity: 1;
  color: rgb(30 30 30 / var(--tw-text-opacity));
}
.text-\\[\\#17477E\\] {
  --tw-text-opacity: 1;
  color: rgb(23 71 126 / var(--tw-text-opacity));
}
.text-\\[\\#04825F\\] {
  --tw-text-opacity: 1;
  color: rgb(4 130 95 / var(--tw-text-opacity));
}
.text-\\[\\#133b69\\] {
  --tw-text-opacity: 1;
  color: rgb(19 59 105 / var(--tw-text-opacity));
}
.text-\\[\\#036C4F\\] {
  --tw-text-opacity: 1;
  color: rgb(3 108 79 / var(--tw-text-opacity));
}
.underline {
  text-decoration-line: underline;
}
.opacity-100 {
  opacity: 1;
}
.opacity-0 {
  opacity: 0;
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.ring-1 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-black {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(0 0 0 / var(--tw-ring-opacity));
}
.ring-opacity-5 {
  --tw-ring-opacity: 0.05;
}
.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-100 {
  transition-duration: 100ms;
}
.ease-in {
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

html,
body {
  margin: 0px;
  height: 100%;
}

body {
  /* margin: 0; */
  
  font-family: 'Poppins';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.container {
  margin: auto;
  max-width: 1280px;
  padding: 1rem;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

.color-white {
  color: #ebd8d0;
}

.two {
  /* background: #ff8e71; */
  height: 100%;
  font-size: 5.5vh;
  color: #ebd8d0;
  margin-top: 8vh;
}

.inline-flex {
  display: inline-flex;
}

.currency-position{
  text-align: right;
  margin-right: 0.5rem;
}

.cal-padding-position{
  padding: 0rem 1rem;
}

.investment-input-width{
  margin-top: 0.8rem;
  text-align: left !important;
}

.frame-bg{
  background-color: #FEF8E0;
}

.eligible-text{
  font-weight: 400;
  font-size: 16px;
}

.eligible-text-mob-alt{
  font-weight: 400;
  font-size: 8px;
}

.eligible-text-mob{
  font-weight: 400;
  font-size: 10px;
}

.eligible-img{
  width: 100px;
  height: 100px;
}

.eligible-img-mob{
  width: 35px;
  height: 35px;
}

.eligible-header{
  font-family: 'Poppins';
  font-size: 48px;
  font-weight: 600;
}

.eligible-header-mob{
  font-family: 'Poppins';
  font-size: 12px;
  font-weight: 600;
}

.investment-input-width-mobile{
  margin-top: 0.5rem;
  text-align: left !important;
}

.investment-width{
  width: 500px !important;
}

.invest-drop-size{
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #434343;
}

.inline {
  display: inline-block;
}

.thumbs {
  right: 0;
  position: absolute;
  bottom: 0;
  z-index: 1;
}

.thumbs-2 {
  right: 0;
  position: absolute;
  bottom: 0;
  z-index: 1;
}

.cal-amount-truncate{
  width: 11rem !important;
  text-align: left !important;
}

.cal-element-width{
  width: 10rem !important;
}

.card-button-main {
  z-index: 4;
  color: #FFFFFF;
  background: transparent;
  border: solid 1px;
  margin-left: 2rem;
  margin-top: 2rem;
}

.card-button {
  width: -moz-fit-content;
  width: fit-content;
}

.card-button-welfare {
  width: -moz-fit-content;
  width: fit-content;
}

.pension-button {
  width: 10rem;
  margin-left: 24rem;
  z-index: 4;
  background: #133B69;
  border: solid;
}

.accordion-width{
  width: 120vh;
}

.mobile-element-sub-header{
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 36px;
  text-align: center;
  color: #133B69;
}

.prod-details-header{
  font-family: 'Poppins';
  font-size: 20px;
  font-weight: 600;
  color: #434343;
}

.prod-details-sub-alt{
  width: 100% !important;
}

.prod-textbox{
  color: #434343;
  font-size: 32px;
  font-weight: 600;
}

.prod-textbox-bg{
  background: #FFFEF8;
  padding: 0.5rem;
}

.prod-cal-button{
  background: #434343;
  color: #fff;
  border-radius: 15px;
}

.prod-cal-button-text{
  font-family: 'Poppins';
  font-weight: 600;
  font-size: 14px;
}

.prod-details-sub{
  width: 400px;
  font-size: 14px;
  font-weight: 400;
  color: #434343;
}

.prod-details-sub-mob{
  width: 300px;
  font-size: 14px;
  font-weight: 400;
  color: #434343;
}

.loan-calculator-card{
  border: solid 1px #F2F2F280;
  border-radius: 15px;
  padding: 2rem;
}

.step-3-w{
  width: 390px;
}

.mobile-element-sub-p{
  /* width: 343px; */
  /* height: 72px; */
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #434343;
}

.mobile-element-header{
  /* width: 263px; */
  height: 72px;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 36px;
  color: #133B69;
}

.element-header-altered{
  color: #404040 !important;
  font-size: 30px !important;
  height: auto !important;
  line-height: normal !important;
}

.element-header{
  /* width: 568px; */
  height: 60px;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-size: 40px;
  line-height: 60px;
  text-align: center;
  color: #133B69;
}

.element-header-alt{
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 36px;
  text-align: center;
  color: #133B69;
}

.element-faq-sub{
  width: 333px;
  height: 24px;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  color: #696969;
}

.element-faq-header{
  width: 303px;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  line-height: 48px;
  text-align: center;
  color: #133B69; 
}

.element-p{
  width: 538px;
  height: 60px;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 30px;
  text-align: center;
  color: #696969;
  flex: none;
  flex-grow: 0;
}

.accordion-header{
  width: 568px;
  height: 60px;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-size: 40px;
  line-height: 60px;
  text-align: center;
  color: #133B69;
}

.accordion-p{
  width: 538px;
  height: 60px;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 30px;
  text-align: center;
  color: #696969;
  flex: none;
  flex-grow: 0;
}

.disclaimer-bubble-alt{
  height: 125px;
  left: 16px;
  top: 936px;
  background: rgba(253, 244, 207, 0.31);
  border-radius: 16px;
}

.accordion-p-alt{
  height: 60px;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 30px;
  text-align: center;
  color: #696969;
  flex: none;
  flex-grow: 0;
}

.loan-account {
  top: 100rem;
  width: 100%;
  /* height: 90vh; */
  /* background: #D1DAE5; */
}

.bubble-font-size{
  font-size: 10px !important;
}

.pension-account {
  top: 100rem;
  width: 100%;
  /* height: -webkit-fill-available; */
  background: #d1dae52e;
}

.mobile-info-card-p {
  font-size: 20px !important;
  width: auto !important;
}

.loan-step-p{
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  color: #696969;
}

.not_found_text{
  width: 136px;
  height: 20px;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 20px;
  color: #FFFFFF;
}

.not_found_image{
  margin: 5rem 0rem;
}

.not_found_button{
  margin-top: 3rem;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 16px 24px;
  gap: 10px;
  width: 184px;
  height: 52px;
  background: #17477E;
  border-radius: 8px;
}

.not_found_heading{
  margin-bottom: 2rem;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-size: 56px;
  line-height: 84px;
  color: #434343;
  flex: none;
}

.not_found_margin{
  margin: 10rem 0rem;
}

.not_found_p{
  width: 336px;
  height: 60px;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 30px;
  color: #434343;
}

.info-card-p {
  width: 270px;
  z-index: 98;
  height: 36px;
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 36px;
  color: #FFFFFF;
  flex: none;
  order: 0;
  flex-grow: 0;
  margin-left: 2rem;
  margin-top: 2rem;
}

.mobile-info-card-p-2 {
  font-size: 12px !important;
  width: auto !important;
}

.info-card-p-2 {
  height: 36px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #FFFFFF;
  flex: none;
  order: 0;
  flex-grow: 0;
  margin-left: 2rem;
  margin-top: 2rem;
  z-index: 3;
}

.info-card-img {
  margin-top: 1.6rem;
}

.mobile-info-card-img {
  margin-top: 0.8rem;
  width: 3rem;
}

.loan-button {
  width: 10rem;
  margin-left: 18rem;
  z-index: 4;
  background: #133B69;
  border: solid;
}

.loan-step-1-color {
  color: #CDA70E;
}

.loan-step-2-color {
  color: #036C4F;
}

.loan-step-3-color {
  color: #133B69;
}

.input-container { /* IE10 */
  display: flex;
  width: 100%;
  margin-bottom: 15px;
}

.button-padding {
  padding: 16px 32px !important;
}

.cal-drop-icon{
  height: 9px;
  /* margin-top: 6px; */
  margin-left: 5px;
}

.learn-display {
  display: inline-flex;
}

.partner-img-alt{
  width: 14rem !important;
  height: 6rem !important;
}

.partner-img-alt-m{
  width: 14rem !important;
  height: 4.5rem !important;
}

.mobile-s-img{
  padding: 0.17rem;
}

.mobile-s-img-alt{
  padding: 0.3rem;
}

.mobile-ec-img{
  padding: 0rem 0.4rem;
}

.partner-img-alt-2{
  padding: 0.5rem;
}

.menu-drop-icon-alt-m{
  margin-left: 9rem !important;
}

.mobile-contact-box {
  margin: auto;
  width: 95%;
  background: #FFFFFF;
  box-shadow: 0px 24px 155px rgba(0, 0, 0, 0.08);
  border-radius: 16px;
}

.contact-box {
  width: 922px;
  /* height: 692px; */
  left: 0px;
  top: 0px;
  background: #FFFFFF;
  box-shadow: 0px 24px 155px rgba(0, 0, 0, 0.08);
  border-radius: 16px;
}

.contact-dropdown {
  border: 0.6px solid #434343;
  border-radius: 8px;
  width: 318px;
  height: 60px;
}

.send-button {
  padding: 0rem 5rem;
  margin-top: 4rem;
}

.send-p {
  display: inline-flex;
}

.bu-send {
  margin-top: auto;
  margin-bottom: auto;
  margin-left: 5px;
}

.contact-area {
  padding: 0rem 45px;
}

.phone-app-ava{
  width: 2rem;
  margin-left: auto;
  margin-right: auto;
  margin-top: 3vh;
}

.phone-short-code {
  width: 27.31px;
  height: 54px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 1vh;
}

.freq-text{
  font-size: 19px;
  border: none;
  font-weight: 500;
  box-shadow: none;
}

.freq-text-alt{
  font-size: 14px;
  border: none;
  box-shadow: none;
}

.list-10{
  padding-left: 1rem !important;
}

.cal-drop-button-width{
  /* width: 22vh !important; */
  width: 16vh !important;
}

.cal-drop-button-width-alt{
  width: 12vh !important;
}

/* .cal-drop-button-width-alt{
  width: 15vh !important;
} */

.drop-down-item-text{
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
  color: #434343;
}

.arrow-width{
  width: 15px !important;
  margin-left: 1rem;
}

.card-verify-icon-alt{
  width: 35px;
  height: 30px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 1vh;
}

.phone-short-code-alt {
  width: 16.97px;
  height: 32.04px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 1vh;
}

.mobile-short-code{
  /* width: 53px; */
  height: 30px;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 30px;
  text-align: center;
  color: #0A0A0A;
}

.card-verify-icon{
  width: 75px;
  height: 55px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 1vh;
}

.short-code {
  width: 74px;
  height: 36px;
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 36px;
  color: #0A0A0A;
  margin-left: auto;
  margin-right: auto;
}

.hr-header {
  width: 25rem;
}

.scan-code {
  width: 408px;
  height: 60px;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 30px;
  color: #696969;
}

.phone-text {
  width: 92px;
  height: 24px;
  font-style: normal;
  text-align: center;
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;
  color: #0A0A0A;
  margin-left: auto;
  margin-right: auto;
  margin-top: 1vh;
}

.home-card-loan{
  margin-left: -10vh;
  margin-top: -3vh;
}

.barcode-ring {
  width: 135px;
  height: 135px;
  left: 100px;
  top: 638px;

  background: #FFFFFF;
  /* Primary color/blue/04 */

  border: 2px solid #133B69;
  border-radius: 16px;
}

.mobile-card-icon-ring-text {
  width: 85px;
  height: 54.19px;
  left: 13px;
  top: 324.31px;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 11px;
  text-align: center;
  color: #0A0A0A;
}

.mobile-app-ring-text{
  width: 85px;
  height: 54.19px;
  left: 13px;
  top: 324.31px;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  color: #0A0A0A;
}

.mobile-app-ring{
  width: 88px;
  height: 88px;
  left: 12px;
  top: 319px;
  background: #FFFFFF;
  border: 1px solid #0A0A0A;
  border-radius: 16px;
}

.app-ring {
  width: 125px;
  height: 135px;
  background: #FFFFFF;
  border: 2px solid #000;
  border-radius: 16px;
}

.dial-ring-color-alt{
  border: 2px solid #036C4F !important;
}

.mobile-dial-ring-alt{
  border: 2px solid #036C4F !important;
}

.verify-card-box{
  border: 2px solid #D2D2D2;
  padding: 1.5rem;
  border-radius: 15px;
}

.verify-card-box-alt{
  border: 2px solid #2E977A !important;
  background-color: #fff !important;
}

.mobile-dial-ring{
  width: 88px;
  height: 88px;
  left: 116px;
  top: 319px;
  background: #FFFFFF;
  border: 1px solid #F6C911;
  border-radius: 16px;
}

.dial-ring {
  width: 135px;
  height: 135px;
  background: #FFFFFF;
  border: 2px solid #F6C911;
  border-radius: 16px;
}

.mobile-contact-input-area {
  height: 160px;
  width: 40vh;
  border: 0.6px solid #434343;
}

.contact-input-area {
  height: 160px;
  width: 46rem;
  border: 0.6px solid #434343;
}

.contact-input-phone {
  display: inline-flex;
  width: 3rem;
  color: #133B69;
  border-right: none !important;
  border: 0.6px solid #434343;
  height: 56px;
  border-top-left-radius: 8.6px;
  border-bottom-left-radius: 8.6px;
}

.contact-input-number {
  display: inline-flex;
  width: 3rem;
  color: #133B69;
  border-left: none !important;
  border: 0.6px solid #434343;
  border-top-right-radius: 8.6px;
  border-bottom-right-radius: 8.6px;
  height: 56px;
  width: 275px;
}

.contact-input {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 16px 72px 16px 8px;
  gap: 8px;
  width: 318px;
  height: 56px;
  background: #FFFFFF;
  border: 0.6px solid #434343;
  border-radius: 8px;
  flex: none;
  /* order: 1; */
  align-self: stretch;
  flex-grow: 0;
}

.goals-img-ht {
  margin-top: -1rem;
  width: 13rem;
}

.mobile-define-box {
  margin: 10px auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 15px 43px;
  gap: 14px;
  width: 156px;
  height: 148px;
  background: #FFFFFF;
  box-shadow: 0px 48px 80px rgba(0, 0, 0, 0.05);
  border-radius: 16px;
}

.define-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 15px 43px;
  gap: 14px;
  width: 210px;
  height: 198px;
  background: #FFFFFF;
  box-shadow: 0px 48px 80px rgba(0, 0, 0, 0.05);
  border-radius: 16px;
}

.mobile-about-img {
  margin: auto;
  width: 100px;
  height: 100px;
  border-radius: 50%;
}

.about-header{
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-size: 56px;
  line-height: 84px;
  text-align: center;
  color: #133B69;
}

.choice-card-text{
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  color: #FFFFFF;
}

.choice-card-img{
  width:18px;
  height:19.21px
}

.choice-card-button{
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  padding: 10px 24px;
  gap: 7px;
  width: 129px;
  height: 45px;
  background: #133B69;
  border-radius: 8px;
}

.page-heading-selected{
  text-decoration-color: #133B69 !important;
  color: #133B69 !important;
}

.page-heading{
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 30px;
  text-decoration: underline;
  text-underline-offset: 8px;
  text-decoration-color: #B4B4B4;
  color: #B4B4B4;
}

.freq-card-button-selected-text{
  color: #fff;
}

.freq-card-button-selected{
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: flex-start;
  padding: 10px 24px;
  gap: 8px;
  background: #133B69;
  border-radius: 8px;
}

.freq-card-button{
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: flex-start;
  padding: 10px 24px;
  gap: 8px;
  background: #EDEDED;
  border-radius: 8px;
}

.main-right-padding{
  padding: 0rem 5rem;
}

.main-padding{
  padding: 2rem 0rem;
}

.team-main-padding{
  padding: 0rem 11rem;
}

.swirl-neg-margin{
  margin-top: -1.5rem;
}

.phones-img-width{
  width: 35rem;
}

.phones-side-width{
  height: 31rem;
  margin: 2rem 0rem;
}

.team-header-margin{
  margin-left: -4rem;
  margin-bottom: 3rem;
}

.team-padding{
  padding: 0rem 3rem;
}

.partner-padding{
  padding: 0rem 5rem;
}

.partner-name-alt{
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #17477E;
  text-align: center;
}

.faq-button-text{
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 30px;
  color: #FFFFFF;
}

.faq-button{
  /* z-index: 999; */
  position: relative;
  justify-content: center;
  align-items: center;
  padding: 16px 32px;
  gap: 10px;
  width: 202px;
  height: 62px;
  background: #17477E;
  border-radius: 8px;
}

.partner-img-with-mobile{
  width: 20rem;
}

.partner-name-alt-mobile{
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 20px;
  color: #133B69;
}

.swirl-padding{
  margin-right: 8rem;
}

.team-name{
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 36px;
  color: #434343;
  text-align: center;
  margin: auto;
}

.team-role{
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #696969;
  text-align: center;
}

.about-sub{
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 30px;
  text-align: center;
  color: #696969;
}

.about-sub-alt{
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 30px;
  color: #696969;
}

.about-img-alt{
  width: 957px;
  height: 424px;
  left: 241px;
  top: 690px;

  background: rgba(217, 217, 217, 0.2);
  border-radius: 58px;
}

.about-img {
  width: 240px;
  height: 240px;
  border-radius: 50%;
}

.business-info {
  width: 816px;
  height: 278.79px;
  background: #395b9f2b;
  box-shadow: 0px 48px 80px rgba(0, 0, 0, 0.05);
  border-radius: 16px;
}

.mobile-business-info {
  margin: auto;
  width: 95%;
  background: #395b9f2b;
  box-shadow: 0px 48px 80px rgba(0, 0, 0, 0.05);
  border-radius: 16px;
}

.place-x {
  float: right;
}

.mobile-nav-text {
  /* width: 81px; */
  height: 30px;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 30px;
  color: #FFFFFF;
  flex: none;
  order: 0;
  flex-grow: 0;
  margin-bottom: 32px;
}

.mobile-nav-bg {
  background: #133B69;
  height: 650px;
  border-radius: 0px 0px 40px 40px;
  top: 0;
  position: absolute;
  width: -webkit-fill-available;
}

.mobile-menu-drop-icon {
  width: 25px;
  height: 20px;  
  margin-top: 6px;
  margin-left: 5px;
}

.cal-drop-icon-alt{
  width: 25px;
  height: 25px;
  margin-top: 20px;
  margin-left: 30px;
  cursor: pointer;
}

.menu-drop-icon {
  width: 25px;
  height: 15px;  
  margin-top: 6px;
  margin-left: 5px;
}

.register-position {
  margin-left: -1rem;
  margin-top: 2rem;
}

.mobile-menu-bar {
  margin-left: -5.2rem;
  width: max-content;
  line-height: 2rem;
  margin-top: 2rem
}

.mobile-dropdown-text {
  height: 30px;
  left: 0px;
  top: 76px;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 30px;
  color: #B2C2D4;
}

.frequency-display{
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  color: #434343;
}

.menu-bar-alt{
  margin-top: auto !important;
  width: 21rem !important;
  height: auto !important;
}

.menu-bar {
  background: white;
  width: 14rem;
  padding: 1rem;
  line-height: 2rem;
  box-shadow: 1px 2px 7px 0px #afafd46b;
  border-radius: 5px;
  margin-top: 2rem
}

.icon {
  padding: 1rem;
  background: #D1DAE5;
  color: #133B69;
  min-width: 100px;
  text-align: center;
  border-radius: 8px 0px 0px 8px;

}

.input-field {
  width: 100%;
  padding: 10px;
  outline: none;
  color: #133B69;
  font-weight: 400;
  font-size: 24px;
  line-height: 36px;
  background-color: #d1dae536;
}

.portfolio-cal {
  width: 647px;
  padding: 3rem 8rem;
  background: #FFFFFF;
  box-shadow: 4px 3px 40px rgba(0, 0, 0, 0.07);
  border-radius: 16px;
}

.mobile-portfolio-cal {
  width: 95%;
  background: #FFFFFF;
  box-shadow: 4px 3px 40px rgba(0, 0, 0, 0.07);
  border-radius: 16px;
}

.mobile-apply-button{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 32px;
  gap: 10px;
  width: 343px;
  height: 56px;
  background: #17477E;
  border-radius: 8px;
  flex: none;
  flex-grow: 0;
}

/* .apply-now-button {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 32px;
  gap: 10px;
  width: 237px;
  height: 56px;
  border-radius: 8px;
  color: #17477E
} */

.element-pension-w{
  width: 527px !important;
}

.element-in-steps {
  width: 274px;
  height: 120px;
  font-style: normal;
  font-weight: 600;
  font-size: 40px;
  line-height: 60px;
  color: #133B69;
  flex: none;
  order: 0;
  flex-grow: 0;
}

.pension-w{
  width: 452px !important;
}

.element-in-steps-p {
  width: 331px;
  /* height: 90px; */
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 30px;
  color: #696969;
  flex: none;
  flex-grow: 0;
}

.loan-step-button {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin-bottom: 1rem;
  padding: 12px 24px;
  gap: 10px;
  width: 100px;
  height: 46px;
  border-radius: 40px;
  flex: none;
  order: 0;
  flex-grow: 0;
}

.loan-step-1 {
  background: #FDF4CF;
}

.loan-step-2 {
  background: #CDE6DF;
}

.loan-step-3 {
  background: #D1DAE5;
}

.mobile-info-card-sm {
  width: 72px;
  height: 72px;
  border-radius: 70px;
  margin-left: 2rem;
  margin-top: 2rem;
  background: #FFFFFF;
}

.info-card-sm {
  /* position: absolute; */
  width: 135px;
  height: 135px;
  margin-left: 2rem;
  margin-top: 2rem;
  border-radius: 70px;
  background: #FFFFFF;
}

.loan-p {
  width: 232px;
  height: 96px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #696969;
}

.welfare-p {
  width: 271px;
  height: 144px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #696969;
  flex: none;
  order: 1;
  flex-grow: 0;
}

.welfare-insurance-card{
  width: 480px;
  height: 417.83px;
  border-radius: 13px;
}

.welfare-insurance-card-1{
  background-color: #2E977A;
}

.welfare-insurance-card-2{
  background-color: #03573F;
}

.mobile-pension-card-1 {
  width: 95%;
  height: -moz-fit-content;
  height: fit-content;
  background-color: #17477E;
  border-radius: 13px;
  margin: auto;
}

.mobile-welfare-card-1 {
  width: 95%;
  height: -moz-fit-content;
  height: fit-content;
  border-radius: 13px;
  margin: auto;
}

.pension-card-1 {
  width: 480px;
  height: 417.83px;
  background-color: #17477E;
  border-radius: 13px;
}

.pension-card-2 {
  width: 480px;
  height: 417.83px;
  background-color: #133B69;
  border-radius: 13px;
}

.box {
  height: 45px;
  overflow: hidden;
  position: relative;
  display: inline-block;
}

.box-mobile {
  height: 25px;
  overflow: hidden;
  position: relative;
  display: inline-block;
}

.barcode-bg {
  border-color: #355f90;
  width: 13rem;
}

.request-text {
  width: 354px;
  height: 96px;
  left: 71px;
  bottom: 53px;
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  line-height: 48px;
  color: #FFFFFF;
}

.text-width-2 {
  width: 318px;
  height: 90px;
}

.text-width {
  width: 404px;
  height: 90px;
}

.landing-img-third{
  width: 70vh;
}

.landing-img-fourth{
  width: 80vh;
}

.landing-text-color {
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 30px;
  color: #696969;
  flex: none;
  order: 1;
  flex-grow: 0;
}

.register-p{
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 30px;
  color: #696969;
  flex: none;
  order: 1;
  flex-grow: 0;
}

.landing-text-position {
  margin-left: auto;
  margin-right: auto;
  margin-top: 18vh;
  margin-bottom: auto;
}

.swirl-position{
  margin: -6rem 25rem;
  width: 9rem;
}

.step-1-item{
  margin-left: 3rem;
  margin-top: 18rem;
}

.landing-img-position {
  /* width: 95vh;
  margin-left: -10rem; */
  width: 120vh;
  margin-left: -19rem;
}

.steps-text {
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 30px;
  color: #133B69;
  flex: none;
  order: 0;
  flex-grow: 0;
}

.last-goal-item{
  width: 238px;
  height: 40px;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  color: #133B69;
  flex: none;
  flex-grow: 0;
}

.steps-button {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin-bottom: 1rem;
  padding: 8px 24px;
  gap: 10px;
  width: 111px;
  height: 46px;
  background: rgba(209, 218, 229, 0.5);
  border-radius: 374px;
  flex: none;
  order: 0;
  flex-grow: 0;
}

.button-margin-left{
  margin-left: auto;
}

.landing-img {
  width: 115vh;
}

.swirl-2-position{
  margin: 0rem 8rem;
}

.step-2-element{
  position: absolute;
  bottom: 10rem;
  right: 6rem;
}

.register-header{
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  line-height: 48px;
  color: #133B69;
}

.register-para{
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 30px;
  color: #696969;
}

.partner-border{
  border: solid 2px #D1DAE5;
  width: -moz-fit-content;
  width: fit-content;
  border-radius: 15px;
  padding: 8px;
}

.partner-text{
  font-family: 'Poppins';
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  text-align: left;
  color: #696969;
}

.partner-text-alt {
  font-family: 'Poppins';
  font-size: 11px;
  font-weight: 600;
  line-height: 16px;
  text-align: left;
  color: #696969;
}

.top-text {
  /* width: 98px; */
  height: 30px;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 30px;
  color: #FFFFFF;
  flex: none;
  order: 0;
  flex-grow: 0;
}

.apply-now-text {
  /* width: 80px; */
  height: 24px;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  color: #FFFFFF;
  flex: none;
  order: 0;
  flex-grow: 0;
}

.apply-now-button-alt{
  margin-left: 24rem !important;
}

.apply-now-button {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 16px 32px;
  gap: 10px;
  width: 144px;
  height: 56px;
  background: #133B69;
  border-radius: 8px;
  flex: none;
  order: 2;
  margin-top: 2rem;
  margin-left: 18rem;
  flex-grow: 0;
}

.top-button {
  /* display: flex; */
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 32px;
  gap: 4px;
  /* width: 190px; */
  height: 62px;
  background: #133B69;
  border-radius: 8px;
  flex: none;
  order: 1;
  flex-grow: 0;
}

.register-text{
  width: 46px;
  height: 20px;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  color: #133B69;
  flex: none;
  order: 0;
  flex-grow: 0;
}

.register-button {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 16px 24px;
  gap: 10px;
  width: 94px;
  height: 52px;
  background: #fff;
  border-radius: 8px;
}

.nav-agent-button-text{
  color: #17477E;
  font-weight: 600;
}

.button-text {
  width: 142px;
  height: 24px;
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 24px;
  color: #FFFFFF;
  flex: none;
  order: 0;
  flex-grow: 0;
}

.nav-agent-button{
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 16px 32px;
  gap: 10px;
  width: -moz-fit-content;
  width: fit-content;
  height: 56px;
  color: #17477E;
  background: transparent;
  border: solid 2px #17477E;
  border-radius: 8px;
}

.blue-button {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 16px 32px;
  gap: 10px;
  width: 206px;
  height: 56px;
  background: #17477E;
  border-radius: 8px;
}

.register-margin {
  padding: 2rem 8rem;
}

.register-margin-2 {
  padding: 2rem 4rem;
}
.screen-icons {
  width: 95%;
}

.mobile-icons {
  width: 75%;
}

.mobile-license {
  margin-right: -1rem;
  float: right;
}

.mobile-plan-card {
  width: 10vh;
}

.mobile-card-pad {
  padding-bottom: 2rem;
}

.mobile-card {
  margin: auto;
  width: 90%;
  height: -moz-fit-content;
  height: fit-content;
  left: 0px;
  top: 0px;
  background: #d1dae545;
  border-radius: 16px;
}

.mobile-nav {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 99;
}

.mobile-center-alt {
  margin-top: 2rem;
  text-align: center;
  font-size: 32px;
}

.mobile-pa-alt {
  text-align: center;
  font-size: 14px;
  margin-bottom: 2rem;
}

.web-pension-vid{
  width: 800px;
  height: 650px;
  margin: auto;
  background: #D2D2D2;
  border-radius: 15px;
}

.web-vid {
  width: 850px;
  height: 450px;
  left: 0px;    
  border-radius: 15px;
  background: #D2D2D2;
}

.mobile-vid {
  margin: auto;
  width: 343px;
  height: 255px;
  left: 16px;
  top: 2182px;

  background: #D9D9D9;
  border-radius: 16px;
}

.mobile-center {
  margin-top: 5rem !important;
  text-align: center;
  font-size: 32px;
}

.mobile-about-us-img {
  margin: auto;
  width: 95%;
  height: 35vh;
  background-repeat: no-repeat;
  background-size: cover;
}

.register-center{
  width: -moz-fit-content;
  width: fit-content;
  text-align: center;
}

.index-scrolling{
  color: #036C4F !important;
}

.dial-bg{
  background: #F1F4F7;
  /* width: fit-content; */
}

.index-heading{
  left: 0%;
  right: 10.03%;
  top: 0%;
  bottom: 6.8%;
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  line-height: 48px;
  color: #133B69;
}

.index-heading-alt{
  left: 0%;
  right: 10.03%;
  top: 0%;
  bottom: 6.8%;
  font-style: normal;
  font-weight: 600;
  font-size: 28px;
  line-height: 48px;
  color: #133B69;
}


.absolute-p {
  position: absolute;
}

.mobile-page-images {
  margin: 2rem 0rem -1rem;
  width: 100%;
  height: 46vh;
  background-repeat: no-repeat;
  background-size: cover;
}

.mobile-page-images-2 {
  margin-top: 2rem;
  margin-left: 0rem;
  width: 43vh;
  height: 35vh;
  background-repeat: no-repeat;
  background-size: cover;
}

.page-images {
  margin-top: 4rem;
  width: 450vh;
  height: 62vh;
  background-repeat: no-repeat;
  background-size: cover;
}

.calculator-img{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 100% 100% !important;
  height: 405px;
  width: 500px;
  margin: 5rem 0rem;
}

.cal-sub-heading{
  height: 24px;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #434343;
}

.cal-sub-heading-mobile{
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #434343;
}

.neg-margin{
  margin-top: -3rem;
}

.neg-margin-mobile{
  margin-top: -1.5rem;
}

.pen-list-item{
  display: list-item;
}

.neg-button-margin{
  margin-top: -1rem;
}

.cal-padding{
  padding: 1rem 2rem;
}

.freq-margin{
  justify-content: center;
  width: -moz-fit-content !important;
  width: fit-content !important;
  display: flex;
  margin-top: 1.2rem !important;
  margin-left: 0rem !important;
}

.expect-label-margin{
  margin-left: 2.5rem !important;
}

.investment-calculator-margin{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 100% 100% !important;
  height: 415px;
  width: 500px;
  margin: 1rem 3rem;
}

.investment-calculator-margin-mobile{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 100% 100% !important;
  width: 370px;
  height: 445px;
  margin: 1rem 0.5rem;
}

.swirl-size{
  width: 6rem;
  height: 6rem;
}

.pen-img{
  width: 5rem;
  height: 5rem;
}

.low-interest-margin{
  margin-top: 33px !important;
}

.low-interest-text-margin{
  margin-top: 28px !important;
}

.team-name-margin-alt-1{
  margin: 2rem 0rem !important;
}

.team-name-margin-alt-2{
  margin: 4rem 0rem !important;
}

.margin-alt{
  margin: 0.5rem;
}

.about-gr-text{
  font-weight: 600 !important;
  color: #036C4F !important;
}

.about-pg-trust{
  color: #F6C911;
}

.about-pg-stability{
  color: #9EBBDC;
}

.about-pg-assurance{
  color: #036C4F;
}

.about-pg-progress{
  color: #133B69;
}

.about-pg-default{
  height: 4rem;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-size: 64px;
  line-height: 96px;
}

.about-pg-default-alt{
  height: 3rem;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-size: 40px;
  text-align: center;
  line-height: 96px;
}

.team-name-mobile{
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 30px;
  color: #434343;
}

.team-role-mobile{
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #696969;
}

.about-define{
  width: 618px;
  height: 108px;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 36px;
  color: #696969;
  text-align: left;
}

.about-bl-text{
  font-weight: 600 !important;
  color: #133B69 !important;
}

.about-heading-sub-width{
  width: 276px;
}



.about-default-text-alt{
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 30px;
  text-align: center;
  color: #696969;
}

.about-default-text{
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 30px;
  text-align: center;
  color: #696969;
}

.about-pg-bg-2-alt{
  padding: 0px 10px !important;
}

.about-heading-sub-mobile{
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  color: #696969;
}

.about-heading-mobile{
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 36px;
  text-align: center;
  color: #133B69;
}

.about-pg-bg-2{
  align-items: center;
  padding: 0px 24px;
  gap: 8px;
  height: 76px;
  left: 1011px;
  top: 95px;
  background: #133B69;
  color: white !important;
  border-radius: 61px;
}

.about-pg-bg-1{
  justify-content: center;
  align-items: center;
  padding: 0px 24px;
  gap: 8px;
  width: 228px;
  height: 76px;
  background: #036C4F;
  border-radius: 61px;
  color: white !important;
}

.pen-margin-alt{
  margin: 0rem 2rem;
}

.pen-margin-alt-mobile{
  margin: 0rem 1.5rem;
}

.tooltip-text{
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  color: #434343;
  width: 273px;
}

.tooltip-text-alt{
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  color: #fff;
}

.alt-mt-2{
  margin-top: 0.3rem !important;
}

.tooltip-contribute-element{
  background: rgb(19 59 106 / 73%) !important;
  left: 0rem;
  top: 2rem;
  border-radius: 5px;
}

.tooltip-left-element{
  width: 305px;
  height: 112px;
  background: rgba(46, 151, 122, 0.05) !important;
  left: -18rem;
  top: 2rem;
  border-radius: 32px;
  padding: 1rem 1.5rem
}

.tooltip-right-element{
  width: 305px;
  height: 112px;
  background: rgba(46, 151, 122, 0.05) !important;
  left: 5rem;
  top: 2rem;
  border-radius: 32px;
  padding: 1rem 1.5rem
}

.pen-sub{
  width: 305px;
  /* height: 48px; */
  left: 583px;
  top: 2008px;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #696969;
}

.pen-heading{
  font-style: normal;
  font-weight: 600;
  font-size: 23px;
  line-height: 36px;
  color: #133B69;
  margin-right: auto;
  /* margin-top: 1rem; */
}

.pen-heading-margin-alt-1{
  margin-top: 22px !important;
}

.pen-heading-margin-alt-2{
  margin-top: 7px !important;
}

.pen-heading-alt-2 {
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 25px;
  color: #133B69;
  margin-right: auto;
}

.pen-heading-alt{
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 36px;
  color: #133B69;
  margin-right: auto;
}

.disclaimer-text{
  width: 560px;
  height: 64px;
  left: 446px;
  top: 1584px;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  color: #696969;
}

.disclaimer-text-alt{
  height: 64px;
  left: 446px;
  top: 1584px;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  color: #696969;
}

.disclaimer-img{
  width: 1rem;
  height: 1rem;
  margin: 0.7rem;
}

.disclaimer-bubble{
  width: 636px;
  height: 84px;
  left: 402px;
  top: 1572px;
  background: rgba(253, 244, 207, 0.31);
  border-radius: 16px;
}

.pension-cal-card{
  width: 374px;
  height: 208px;
  background: #f0f8ffd1;
  border-radius: 32px;
}

.pension-cal-card-alt{
  height: 190px;
  background: #f0f8ffd1;
  border-radius: 32px;
}

.ul-postion-alt{
  width: 6rem;
  left: 0rem;
}

.ul-postion-alt-2{
  left: 0rem;
}

.ul-postion{
  width: 15rem;
  left: -3rem;
}

.voda_img_position{
  width: 10rem;
  margin-left: 5rem;
}

.expected-amount-position{
  text-align: left !important;
  width: 10rem !important;
  margin-left: -0.5rem;
}

.expected-amount-position-mobile{
  text-align: left !important;
  width: 80px !important;
}

.partner-img{
  width: 38.18px;
  height: 40px;
}

.select-position{
  position: absolute;
  top: 74.5rem;
  left: 29.5rem;
}

.partner-name{
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  color: #8E8E8E;
}

.partner-description{
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  color: #696969;
}

.listbox-drop-span{
  width: 18rem;
  display: inline-flex;
}

.cal-element-alt-1{
  text-align: center;
  height: 48px !important;
  font-style: normal;
  font-weight: 400;
  font-size: 32px;
  line-height: 48px;
  background: transparent;
  width: 2rem;
}

.box-frame-alt-3{
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px;
  gap: 25px;
  height: 52px;
  width: 100% !important;
  border: 0.6px solid #696969;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px
}

.box-frame-alt-2{
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px;
  gap: 25px;
  height: 48px;
  border: 0.6px solid #696969;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px
}

.box-frame-alt-4{
  width: 105px !important;
}

.box-frame-alt-5{
  width: 95% !important;
}

.box-frame-alt-6{
  width: 90% !important;
}

.box-frame-alt{
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px;
  gap: 25px;
  width: auto;
  height: 52px;
  border: 0.6px solid #696969;
  border-radius: 8px;
}

.box-frame-text{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  /* padding: 4px 8px; */
  gap: 8px;
  width: 55px;
  height: 32px;
  background: rgba(19, 59, 105, 0.18);
  border-radius: 8px;
}

.box-frame{
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px;
  gap: 25px;
  width: 65px !important;
  height: 52px;
  border: 0.6px solid #696969;
  border-radius: 8px;
  /* transform: matrix(-1, 0, 0, 1, 0, 0); */
}

.cal-element-alt-1::placeholder {
  height: 48px;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 32px;
  line-height: 48px;
  color: #1E1E1E;
}

.cal-element{
  text-align: center;
  height: 48px !important;
  font-style: normal;
  font-weight: 400;
  font-size: 32px;
  line-height: 48px;
  background: transparent;
  width: 2rem;
}

.cal-element-mobile{
  text-align: center;
  height: 48px !important;
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 48px;
  background: transparent;
  width: 3rem;
}

.cal-element-mobile::placeholder {
  height: 48px;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 48px;
  color: #1E1E1E;
}

.result-bg{
  background: rgba(19, 59, 105, 0.03);
}

.sub-heading-mobile{
  font-size: 12px !important;
}

.expected-result-p-alt{
  font-size: 14px !important;
}

.span-neg-margin{
  margin-right: 1rem;
}

.span-neg-margin-left{
  margin-left: -3rem;
}

.expected-result-para{
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 36px;
  color: #434343;
}

.expected-result-p{
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 19px;
  line-height: 36px;
  color: #434343;
  display: inline-flex;
}

.expected-result-bg{
  background: #D1DAE5;
}

.cal-element-alt{
  width: 4rem !important;
}

.cal-element-alt-2{
  width: 8rem !important;
}

.item-button{
  background: #133b69;
  color: white;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 24px;
  gap: 10px;
  font-size: 1.5rem;
  font-weight: 600;
  height: 52px;
  border: 1px solid #17477E;
  border-radius: 30px;
}

.item-button-alt-2 {
  color: #c9c9c9 !important;
  background: #dad7cc !important;
  border: 1px solid #d9d7cc !important;
}

.item-button-alt{
  color: #133b69 !important;
  background: #F6C911 !important;
  border: 1px solid #F6C911 !important;
}

.calculator-button{
  background: #133b69;
  color: white;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 24px;
  gap: 10px;
  width: 259px;
  height: 52px;
  border: 1px solid #17477E;
  border-radius: 8px;
}

:where(.vi__container){
  width: 100% !important;
  height: 75px !important;
  line-height: 75px !important;
}

.verification-container{
  gap: 2rem;
  width: 100%;
}

:where(.vi__character--selected){
  outline: 2px solid #133b69 !important;
  color: #133b69 !important;
}

.vi__character{
  font-size: 42px !important;
  border-radius: 10px;
  background-color: #f5f5f5;
  border: none;
  width: 100%;
}

.custom-verification-character:focus {
  border-color: black; /* Change border color on focus */
}

.verify-card-box-button{
  background: #133b69;
  color: white;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 24px;
  gap: 10px;
  width: '100%';
  height: 52px;
  border: 1px solid #17477E;
  border-radius: 8px;
  font-size: 20px;
  font-weight: 600;
}

.auto-margin{
  margin: 0 auto;
}

.cal-element-alt-3{
  width: 11rem !important;
}

.cal-amount-alt-1{
  margin-top: 0.5rem !important;
  margin-left: unset !important
}

.cal-amount-alt{
  margin-top: 12px;
  margin-left: 0.3rem;
}

.result-yrs{
  font-size: 14px !important;
  margin-left: 5px;
}

.result-show-graph-text{
  height: 20px;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  color: #17477E;
}

.result-show-graph{
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 24px;
  gap: 10px;
  width: 140px;
  height: 52px;
  border: 1px solid #17477E;
  border-radius: 8px;
}

.result-back-button{
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 24px;
  gap: 10px;
  width: 259px;
  height: 52px;
  border: 1px solid #17477E;
  border-radius: 8px;
}

.result-alt{
  font-size: 16px;
  margin-right: 5px;
  margin-top: 13px;
}

.cal-element::placeholder {
  height: 48px;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 32px;
  line-height: 48px;
  color: #1E1E1E;
}

.cal-heading{
  height: 48px;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  line-height: 48px;
  text-align: center;
  color: #133B69;
  margin-top: 1rem;
}

.cal-heading-mobile{
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 36px;
  text-align: center;
  padding: 0.5rem;
  color: #133B69;
}

.first-image {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  width: 100%;
  object-fit: cover;
}

.spinner-position-alt{
  margin: auto !important;
}

.spinner-position{
  margin: 10rem auto;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.vl {
  border-left: 1px solid black;
  height: 70px;
}

.flag-padding{
  padding: 2rem 1rem;
}

.bog-padding{
  padding: 2rem 1rem;
}

hr.default {
  border-top: 1px solid black;
  width: 55rem;
  margin-top: 3rem;
  margin-bottom: 3rem;
}

hr.default-mobile {
  border-top: 1px solid black;
  width: 20rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.img-width{
  width: 2rem;
}

.mobile-first-image-alt{
  position: absolute;
  width: 513px;
  height: 388.23px;

  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.2) 82.81%), url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.mobile-first-image {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: 100% 100% !important;
}

.second-image {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.mobile-second-image{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

.third-image {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

.mobile-third-image{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

.about-image {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

.fourth-image {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

.mobile-fourth-image{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}

.pension-card-plan {
  width: 273px;
  height: 272px;
  left: 100px;
  top: 1256px;
  background: #FFFFFF;
  border-radius: 8px;
}

.pension-card-plan-alt:hover {
  box-shadow: 0px 19px 39px rgba(38, 38, 38, 0.07);
}

.welfare-card-plan {
  box-sizing: border-box;
  width: 318px;
  height: 328px;
  left: 100px;
  top: 1168px;
  background: #FFFFFF;
  border: 1px solid #FFFFFF;
  border-radius: 8px;
}

.welfare-card-plan-alt:hover {
  box-shadow: 0px 19px 39px rgba(38, 38, 38, 0.07);
}

.mt-override {
  margin-top: 5rem !important
}

.app-w{
  width: 6rem;
  margin: auto;
}

.hr-vertical-sm{
  background-color: #000;
  color: #9da4abd1;
  -webkit-transform: rotate(90deg);
  width: 1.2rem;
  height: 1px;
  border: 0px;
  margin-top: 0.6rem;
  overflow: hidden;
}

.hr-vertical {
  background-color: #9da4abd1;
  color: #9da4abd1;
  -webkit-transform: rotate(90deg);
  width: 4rem;
  height: 2px;
  border: 2px;
  margin-left: 7px;
  overflow: hidden;
}

.journey-card{
  margin: auto;
  width: 90%;
  height: -moz-fit-content;
  height: fit-content;
  left: 0px;
  top: 0px;
  background: #FFFFFF;
  box-shadow: 0px 19px 39px rgba(38, 38, 38, 0.07);
  border-radius: 8px;
}

.mobile-sign-heading{
  width: 265px;
  height: 72px;
  left: 32px;
  top: 3308px;
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 36px;
  color: #FFFFFF;
}

.mobile-sign-button {
  width: 119px;
  height: 52px;
  background: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sign-button {
  width: 10rem;
  height: 3rem;
  background: #1e4f86fc;
  /* margin: 0 auto; */
  display: flex;
  align-items: center;
  justify-content: center;
}

.address-padding{
  padding: 0rem 1.5rem;
}

.sign-up-mb {
  margin-bottom: 2rem !important;
}

.goal-heading{
  width: auto;
  height: 96px;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-size: 30px;
  line-height: 48px;
  color: #133B69;
  order: 0;
  flex-grow: 0;
}

.goal-sub-height{
  height: 50px !important;
}

.goal-text{
  width: 340px;
  height: 90px;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 30px;
  color: #696969;
  flex: none;
  order: 1;
  flex-grow: 0;
}

.goal-img{
  width: 10rem;
}

.bg-default-light-gray{
  background-color: #e8e8e880;
}

::placeholder {
  /* padding: 1rem; */
  opacity: 1; /* Firefox */
}

.mobile-register-top{
  margin-top: 5rem;
  width: 90%;
}

.register-top {
  margin-top: 8rem;
  height: 203px;
}

.footer-hidden {
  visibility: hidden;
}

.sign-text {
  color: white;
  font-weight: 400;
  background-color: #355f90;
  padding: 5px;
}

.sign-text:focus{
    outline: 0.1em solid white;
}

.mobile-image-card {
  font-size: 10px !important; 
}

.image-card {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px;
  gap: 10px;
  width: max-content;
  position: absolute;
  font-size: 12px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
  border-radius: 16px;
}

.welfare-color{
  color: #036C4F;
}

.img-welfare-card {
  background: #F4FFFC;
  color: #036C4F;
}

.img-loan-card {
  background: #FFFAF8;
  color: #804527 !important;
}

.img-pension-card {
  background: #F7FAFF;
}

.sign-text::placeholder {
  color: white !important;
}

.sign-text::-ms-input-placeholder { /* Internet Explorer 10-11 */ /* Microsoft Edge */
  color: white !important;
}

.plan-width{
  width: 26rem !important;
}

.swirl-padding {
  padding: 0rem 20rem !important;
}

.plan-width-p{
  width: 26rem !important;
}

.mobile-accordion-color{
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 25px;
  color: #696969;
}

.accordion-color{
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 36px;
  color: #696969;
}

.accordion-color:focus{
  color: #133B69 !important;
}

.mobile-accordion-color:focus{
  color: #133B69 !important;
}

.privacy-sub-p-alt{
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  margin-top: 1rem;
  line-height: 30px;
  color: #133B69;
}

.privacy-header{
  height: 60px;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-size: 40px;
  text-align: center;
  line-height: 60px;
  color: #133B69;
}

.extra-margin-top{
  margin-top: 2rem !important;
}

.extra-margin-top-alt{
  margin-top: 4rem !important;
}

.mobile-privacy-header-alt{
  font-size: 32px !important;
  text-align: center !important;
}

.mobile-privacy-header{
  height: 60px;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-size: 40px;
  text-align: left;
  line-height: 60px;
  color: #133B69;
}

.privacy-sub-header{
  height: 30px;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 30px;
  color: #133B69;
}

.privacy-padding{
  padding: 0rem 1.3rem;
}

.privacy-header-width{
  width: 280px !important;
  height: 60px !important;
}

.privacy-sub-width{
  width: 280px !important;
  height: 90px !important;
}

.privacy-sub-width-alt{
  width: 280px !important;
  height: 60px !important;
}

.privacy-para-padding{
  padding: 0rem 5rem;
}

.mobile-privacy-para-padding{
  padding: 0rem 2rem;
}

div.scroll{
  height: 200vh;
  overflow-x: hidden;
  overflow-y: auto;
  text-align:justify;
}

.privacy-sub-paragraph{
  height: 30px;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 30px;
  color: #434343;
}

.privacy-para-sub-header{
  font-size: 18px !important;
}

.privacy-sub-p{
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  margin-top: 1rem;
  line-height: 30px;
  color: #434343;

}

.privacy-sub-alt{
  width: auto !important;
}

.privacy-sub-mobile{
  width: 340px;
  height: 72px;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  color: #434343;
}

.privacy-sub{
  width: 402px;
  height: 30px;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 30px;
  text-align: center;
  color: #696969;
}

.mobile-privacy-sub-alt{
  font-size: 14px !important;
  text-align: center !important;
}

.mobile-privacy-sub{
  height: 30px;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 30px;
  text-align: left;
  color: #696969;
}

.img-icon-width {
  width: 37vh !important;
  max-width: 6vh;
}

.pension-card {
  margin-left: -12vh;
  margin-top: 18vh;
}

.mobile-pension-card {
  margin-left: -3vh;
}

.welfare-heading{
  width: 297px;
  height: 72px;
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 36px;
  color: #133B69;
}

.welfare-card {
  margin-bottom: 3vh;
}

.mobile-welfare-card{
  margin-left: -12vh;
  margin-top: -3vh;
}

.mobile-loan-card {
  margin-left: -13vh;
  margin-top: -3vh;
}

.loan-card {
  margin-right: -10vh;
}

.box::before {
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  content: '';
  height: 10px;
  position: absolute;
  /* background: linear-gradient(180deg, #ff8e71, rgba(255, 142, 113, 0)); */
}
.box::after {
  left: 0;
  bottom: 0;
  z-index: 1;
  width: 100%;
  content: '';
  height: 10px;
  position: absolute;
  /* background: linear-gradient(180deg, rgba(255, 142, 113, 0), #ff8e71); */
}

p {
  float: left;
}

.item-1 {
  padding: 0px 25px !important;
}

.item-3 {
  padding: 10px 18px !important;
}

.coming-soon{
  width: 132px;
  height: 30px;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 30px;
  color: #696969;
}

.scroll-effect{
  animation: scrollUp 5s ease-in-out infinite normal;
}

ul {
  float: right;
  margin: 0;
  padding: 0;
}
ul li {
  opacity: 1;
  height: 50px;
  /* padding: 0px 15px; */
  list-style: none;
}

.box-margin{
  margin-left: 0.3rem;
  margin-top: 1rem;
}

@keyframes scrollUp {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-80%);
  }
}

#container {
  color:#999;
  text-transform: uppercase;
  font-size:36px;
  font-weight:bold;
  padding-top:200px;  
  position:fixed;
  width:100%;
  bottom:45%;
  display:block;
}

.div-margin {
  margin-top: 3px;
}

.fade-in-text {
  font-size: 60px;
  animation: fadeIn 15s;
  -webkit-animation: fadeIn 15s;
  -moz-animation: fadeIn 15s;
  -o-animation: fadeIn 15s;
  -ms-animation: fadeIn 15s;
  opacity: 1;
}

@keyframes fadeIn {
  0% { opacity: 0; }
  100% { opacity: 1; }
}

.animated {
  background-repeat: no-repeat;
  background-position: left top;
  animation-duration: 3s;
  animation-fill-mode: both;
  animation-name: fadeInDown;
}

/* @-webkit-keyframes fadeInLeft {
0% {
   opacity: 0;
   -webkit-transform: translateX(20px);
}
100% {
   opacity: 1;
   -webkit-transform: translateX(0);
}
} */
/* 
@keyframes fadeInLeft {
0% {
   opacity: 0;
   transform: translateX(20px);
}
100% {
   opacity: 1;
   transform: translateX(0);
}
} */

/* .fadeInLeft {
  -webkit-animation-name: fadeInLeft;
  animation-name: fadeInLeft;
} 
 */


/* .reveal {
  position: relative;
  opacity: 0;
}

.reveal.active {
  opacity: 1;
} */

/* .active.fade-bottom {
  animation: fade-bottom 1s ease-in;
}

.active.fade-left {
  animation: fade-left 0s ease-in;
}

.active.fade-right {
  animation: fade-right 0s ease-in;
}

@keyframes fade-bottom {
  0% {
    transform: translateY(50px);
    opacity: 1;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
} */
/* @keyframes fade-left {
  0% {
    transform: translateX(-100px);
    opacity: 1;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes fade-right {
  0% {
    transform: translateX(100px);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
} */

.goal-heading-max{
  width: max-content !important;
}

@media screen and (max-width: 768px) {
  .investment-calculator-margin{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: 100% 100% !important;
    height: 415px;
    margin: auto;
  }

  .nav-agent-button-text {
    color: #17477E;
    font-weight: 600;
    font-size: 15px;
  }

  .nav-agent-button {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 10px 10px;
    gap: 10px;
    width: -moz-fit-content;
    width: fit-content;
    height: 45px;
    color: #17477E;
    background: transparent;
    border: solid 2px #17477E;
    border-radius: 8px;
}

  .eligible-img {
    width: 70px;
    height: 80px;
  }

  .element-header-altered {
    color: #404040 !important;
    font-size: 25px !important;
    height: auto !important;
    line-height: normal !important;
  }

  .element-header {
    height: 45px;
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 600;
    font-size: 30px;
    line-height: 30px;
    text-align: center;
    color: #133B69;
}
  
  .about-header{
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 600;
    font-size: 30px;
    line-height: 30px;
    text-align: center;
    color: #133B69;
  }

  .react-pdf__Page__canvas {
    margin: 0 auto;
    display: block;
    -webkit-user-select: none;
            user-select: none;
    width: 100% !important;
    height: 841px;
  }
  
  .page-images {
    margin-top: 4rem;
    width: inherit;
    height: 62vh;
    background-repeat: no-repeat;
    background-size: cover;
  }

  .accordion-width {
    width: auto;
  }

  .apply-now-button{
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 16px 32px;
    gap: 10px;
    width: 144px;
    height: 56px;
    background: #133B69;
    border-radius: 8px;
    flex: none;
    order: 2;
    margin-top: 2rem;
    margin-left: 3rem;
    flex-grow: 0;
  }

  .request-text {
    width: 320px;
    height: 100px;
    left: 70px;
    bottom: 53px;
    font-style: normal;
    font-weight: 600;
    font-size: 30px;
    line-height: 48px;
    color: #FFFFFF;
  }

  .top-button {
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 16px 32px;
    gap: 4px;
    width: 222px;
    height: 62px;
    background: #133B69;
    border-radius: 8px;
    flex: none;
    flex-grow: 0;
  }
}

@media screen and (min-device-width: 1024px) and (max-device-width: 2024px) {
  .goal-heading{
    width: 300px;
    height: 96px;
    font-style: normal;
    font-weight: 600;
    font-size: 25px;
    line-height: 48px;
    color: #133B69;
    order: 0;
    flex-grow: 0;
  }
}

@media screen and (max-device-width: 480px)
  and (orientation: portrait) {
    .when-to-show{
      display: none;
    }
  }

@media screen and (max-device-width: 640px)
and (orientation: landscape) {
  .when-to-show{
    display: none;
  }
}

@media screen and (max-device-width: 640px) {
  .when-to-show{
    display: none;
  }
}

@media (device-height: 568px) and (device-width: 320px)
  and (-webkit-min-device-pixel-ratio: 2) {
    .when-to-show{
      display: none;
    }
  }

@media (min-device-height: 667px) and (min-device-width: 375px)
and (-webkit-min-device-pixel-ratio: 3) {
  .when-to-show{
    display: none;
  }
}


@media screen and (min-device-width: 768px)
  and (max-device-width: 1024px) {
    .when-to-show{
      display: block;
    }

    .react-pdf__Page__canvas {
      margin: 0 auto;
      display: block;
      -webkit-user-select: none;
              user-select: none;
      width: 100% !important;
      height: 841px;
    }

    .register-mid-img{
      width: 40vh !important;
    }

    .page-images {
      margin-top: 4rem;
      width: inherit;
      height: 62vh;
      background-repeat: no-repeat;
      background-size: cover;
    }

    .request-text {
      width: 340px;
      height: 96px;
      left: 71px;
      bottom: 53px;
      font-style: normal;
      font-weight: 600;
      font-size: 32px;
      line-height: 48px;
      color: #FFFFFF;
    }

    .pension-card {
      margin-left: 0vh;
      margin-top: 25vh;
    }

    .loan-card {
      margin-right: -1vh;
    }

    .nav-items-margin{
      margin-left: -6rem;
    }

    .accordion-width {
      width: auto;
    }
  }

  .landing-header{
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 600;
    font-size: 56px;
    line-height: 84px;
    color: #133B69;
  }

  .note::after {
    content: '';
    width: 20%;
    height: 2px;
    border-radius: 999px;
    background-color: #036C4F;
    /* background: linear-gradient(135deg, rgba(43,171,217,1) 0%, rgba(0,130,200,1) 100%); */
    position: absolute;
    top: -1.8em;
    left: 0;
  }
  .note {
    font-size: 0.8em;
    color: #036C4F;
    position: relative;
    margin-top: 4em;
  }
  
  /* Scroller styling */
  .mobile-scroller{
    height: 1.6rem;
    line-height: 1.7em;
    position: relative;
    overflow: hidden;
    width: 6.3em;
    margin-left: 0.5rem;
    display: inline-block;
  }

  .mobile-scroller > span {
    color: #036C4F;
    position: absolute;
    font-style: normal;
    font-weight: 600;
    font-size: 28px;
    top: 0;
    animation: slide 5s infinite;
    display: inline-block;
  }

  .scroller {
    height: 3rem;
    line-height: 1.23em;
    position: relative;
    overflow: hidden;
    width: 5em;
    margin-left: 1rem;
    display: inline-block;
  }

  .scroller > span {
    color: #036C4F;
    position: absolute;
    font-style: normal;
    font-weight: 600;
    font-size: 56px;
    top: 0;
    animation: slide 5s infinite;
    display: inline-block;
  }

  @keyframes slide {
    0% {
      top: 0;
    }
    25% {
      top: -1em;
    }
    50% {
      top: -2.1em;
    }
    /* 75% {
      top: -3.6em;
    } */
  }

/* .goal-move{
  -webkit-animation:fadeIn 5.6s linear;
  animation:fadeIn 5.6s linear;
  -webkit-animation-fill-mode:both;
  animation-fill-mode:both;
} */

.goal-move div:nth-child(1){
  animation-delay:4.26s;
}

.goal-move div:nth-child(2){
  animation-delay:6.6s;
}

.goal-move div:nth-child(3){
  animation-delay:10.76s;
}

.goal-move div:nth-child(4){
  animation-delay:12s;
}

.dropdown {
  display: inline-block;
  width: 200px;
  margin-left: 0.3rem;
}

.dropdown-header {
  cursor: pointer;
  display: flex;
  align-items: center;
}

.dropdown-body {
  background-color: #fff;
  position: absolute;
  padding: 5px;
  border-top: 1px solid #E5E8EC;
  display: none;
}

.dropdown-body.open {
  display: block;
}

.dropdown-item {
  padding: 10px;
}

.dropdown-item:hover {
  cursor: pointer;
}

.dropdown-item-dot {
  opacity: 0;
  color: #91A5BE;
  transition: all .2s ease-in-out;
}

.dropdown-item-dot.selected {
  opacity: 1;
}

.icon {
  font-size: 13px;
  color: #91A5BE;
  transform: rotate(0deg);
  transition: all .2s ease-in-out;
}

.icon.open {
  transform: rotate(90deg);
}

.contr-margin{
  margin-left: -2rem;
}

.input-amount{
  font-size:1.3em; padding:.5em;
}

#hide {
  position: absolute;
  opacity: 0;
  z-index: -100;
  white-space: pre;
}

.machine-width{
  min-width: 25px;
  padding: 0;
}

.left-side-alt{
  height: auto !important;
}

.left-side{
  height: 100vh;
  background: rgba(19, 59, 105, 0.08);
}

.add-beneficiary-text{
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  color: #17477E;
}

.add-beneficiary-button{
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 24px;
  gap: 4px;
  border: 1px solid #17477E;
  border-radius: 60px;
}

.left-side-image-position{
  position: absolute;
  right: 0;
  width: 15rem;
  bottom: 0;
  z-index: 1;
}

.get-started-date{
  padding: 5px 8px !important;
  align-items: center !important;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  color: #696969;
}

.left-side-text-position{
  margin: 7rem 4rem;
  z-index: 99;
}

.left-side-heading{
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-size: 56px;
  line-height: 84px;
  color: #133B69;
}

.left-side-sub-heading{
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 30px;
  color: #696969;
}

.right-side{
  margin: 5rem 7rem;
}

.upload-box{
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px 21px 10px 8px;
  gap: 8px;
  width: 284px;
  height: 52px;
  border: 0.6px solid #434343;
  border-radius: 8px;
  flex: none;
  flex-grow: 0;
}

.avatar-upload .avatar-edit input {
  display: none;
}
.avatar-upload .avatar-edit input + label {
  display: inline-block;
  /* height: 65px;  */
  margin-bottom: 0;
  border-radius: 100%;
  cursor: pointer;
  font-weight: normal;
  transition: all .2s ease-in-out;
}

.avatar-upload .avatar-edit input + label::before {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  margin-right: 1rem;
  margin-top: 5px;

}

.avatar-upload .avatar-edit input + label:after {
  content: 'Click to upload';
  color: #757575;
}


.right-side-heading{
  /* width: 336px; */
  text-align: center;
  height: 30px;
  margin: 0rem 10rem;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 30px;
  color: #434343;
}

.side-heading{
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  line-height: 48px;
  color: #133B69;
}

.side-heading-sub{
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #696969;
}

.get-started-text-label{
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  color: #434343;
}

.get-started-border{
  border: 0.6px solid #434343;
  border-radius: 8px;
  width: 286px;
}
.get-started-input-choice{
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 10px 72px 10px 8px;
  gap: 8px;
  width: 180px;
  height: 40px;
  border: 0.6px solid #434343;
  border-radius: 8px;
}

.get-started-input-alt-2{
  width: 100% !important;
}

.get-started-input-alt{
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 10px 38px 10px 8px;
  border-top-left-radius: 8.6px;
  border-bottom-left-radius: 8.6px;
  border: solid 0.6px #434343;
  border-right: none;
  gap: 8px;
  width: 20px;
  height: 40px;
  font-size: 12px;
}

.amount-currency{
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 40px;
  line-height: 60px;
  color: #1E1E1E;
}

.get-started-amount-card{
  height: 152px;
  background: #B2C2D4;
}

.get-started-input-box-alt-1{
  width: 100% !important;
}

.get-started-input-box-alt{
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 10px 38px 10px 8px;
  border-top-right-radius: 8.6px;
  border-bottom-right-radius: 8.6px;
  border: solid 0.6px #434343;
  border-left: none;
  gap: 8px;
  width: 240px;
  height: 40px;
  font-size: 12px;
}

.get-started-input{
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 10px 72px 10px 8px;
  gap: 8px;
  width: 286px;
  height: 40px;
  border: 0.6px solid #434343;
  border-radius: 8px;
}

.get-started-input::placeholder{
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  color: #696969;
}

.prefix-text{
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  color: #696969;
  margin: auto;
}

.phone-number-instruction{
  width: 284px;
  height: 40px;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  color: #156CE1;
}

.retirement-button-text{
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  color: #17477E;
  display: inline-flex;
}

.bi-arrow-right-margin{
  margin: 3px 5px;
}

.calculator-scroll-text{
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  color: #133B69;
}

.calculator-scroll-text-alt{
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  color: #8E8E8E;

}

.calculator-scroll-button-alt{
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
  width: 204px;
  height: 40px;
  background: rgba(209, 218, 229, 0.5);
  border: 2px solid #D2D2D2;
  border-radius: 24px;
}

.calculator-scroll-button{
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
  width: 206px;
  height: 40px;
  background: rgba(209, 218, 229, 0.5);
  border: 2px solid #133B69;
  border-radius: 24px;

}

.currency-amount-text{
  background: transparent;
  font-size: 40px;
  width: 15rem;
  font-style: normal;
  font-weight: 600;
}

.currency-amount-tip{
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 8px;
  line-height: 20px;
  color: #F24A4A;
  margin-left: 1rem;
}

.frequency-border{
  border: 0.6px solid #434343;
  border-radius: 8px;
  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
}

.currency-amount-text::placeholder {
  font-size: 40px;
  width: 15rem;
  font-style: normal;
  font-weight: 600;
  color: #191919
}


.currency-position{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.retirement-button{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 24px;
  gap: 4px;
  /* width: 233px; */
  height: 56px;
  left: 98.12px;
  top: 928px;
  border: 1px solid #17477E;
  border-radius: 8px;
}

.choose-gender-img{
  /* width: 7rem; */
  height: 2.5rem;
}

.network-width{
  width: 80px;
  height: 80px;
}

.network-width-alt{
  height: 50px;
}

.network-width-alt-mobile{
  height: 35px;
}

.get-started-button-alt{
  width: 350px !important;
}

.get-started-back-position{
  margin: 1rem 4rem;
}

.get-started-button{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 32px;
  gap: 10px;
  width: 432px;
  height: 56px;
  background: #133B69;
  border-radius: 8px;
}

.get-started-button-altered{
  width: -moz-fit-content !important;
  width: fit-content !important;
}

.get-started-button-text{
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  color: #FFFFFF;
}

.network-img-border{
  border: 1px solid #133B69;
  border-radius: 8px;
}

div.scrollmenu {
  overflow: auto;
  white-space: nowrap;
}

div.scrollmenu button {
  display: inline-block;
  text-align: center;
  text-decoration: none;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.pinBox {
  --width: 330px;
  --height: 76px;
  --spacing: 56px;
  display: inline-block;
  position: relative;
  width: 235px;
  height: var(--height);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___}); 
  background-repeat: space;
  background-position: initial;
}


.pin-box-mobile {
  --width: 22rem;
  --height: 76px;
  --spacing: 66px;
  display: inline-block;
  position: relative;
  height: var(--height);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___}); 
  background-repeat: space;
  background-position: initial;
}

.pin-entry-mobile {
  position: absolute;
  padding-left: 30px;
  font-family: 'Poppins';
  font-size: 33px;
  height: 75px;
  letter-spacing: 82px;
  background-color: transparent;
  border: 0;
  outline: none;
  clip: rect(0px, calc(var(--width) - 21px), var(--height), 0px);
}

.pinEntry {
  position: absolute;
  padding-left: 25px;
  font-family: 'Poppins';
  font-size: var(--spacing);
  height: var(--height);
  letter-spacing: var(--spacing);
  background-color: transparent;
  border: 0;
  outline: none;
  clip: rect(0px, calc(var(--width) - 21px), var(--height), 0px);
}

#partitioned {
  padding-left: 15px;
  letter-spacing: 42px;
  border: 0;
  
  background-image: linear-gradient(to left, black 70%, rgba(255, 255, 255, 0) 0%);
  background-position: bottom;
  background-size: 50px 1px;
  background-repeat: repeat-x;
  background-position-x: 40px;
  width: 195px;
  outline : none;
}

.pin-code-1{ 
  padding: 0; 
  /* margin: 0 auto;  */
  /* display: flex; */
  justify-content:center;
  
} 
 
.pin-code-1 input { 
  border: none;
  text-align: center;
  margin-right: 35px;
  width: 48px;
  height: 48px;
  border: 0.6px solid #696969;
  border-radius: 8px;
  font-size: 20px;
  line-height: 30px;
  color: #696969;
} 

.pin-code-1 input:focus { 
  border: 1px solid #573D8B;
  outline:none;
} 

.pin-code{ 
  padding: 0; 
  /* margin: 0 auto;  */
  /* display: flex; */
  justify-content:center;
  
} 
 
.pin-code input { 
  border: none;
  text-align: center;
  margin-right: 35px;
  width: 48px;
  height: 48px;
  border: 0.6px solid #696969;
  border-radius: 8px;
  font-size: 20px;
  line-height: 30px;
  color: #696969;
} 

.pin-code input:focus { 
  border: 1px solid #573D8B;
  outline:none;
} 


.pincode::-webkit-outer-spin-button,
.pincode::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.pdf-layout-alt{
  height: 40vh;
  width: 55rem;
  margin: 2rem auto;
}

.all-page-container {
  height: 100%;
  max-height: 500px;
  overflow: auto;
}

.react-pdf__Page {
  margin-top: 10px;
}
.react-pdf__Page__textContent {
  border: 1px solid darkgrey;
  box-shadow: 5px 5px 5px 1px #ccc;
  border-radius: 5px;
}

.react-pdf__Page__annotations{
  width: 75% !important;
  height: 0px !important;
}

.coming-soon-container{
  max-width: 100%;
}

.coming-soon-container-alt{
  height: 100vh !important;
  width: 100% !important;
}

.coming-soon-container img {
  max-width: 100%;
  height: auto;
}

.react-pdf__Page__annotations.annotationLayer {
  padding: 20px;
}

.react-pdf__Page__canvas {
  margin: 0 auto;
  display: block;
  -webkit-user-select: none;
          user-select: none;
  /* width: 100% !important; */
  height: 841px;
}

.pdf-layout{
  border: solid 2px;
  width: 49rem;
  margin: 2rem auto;
  overflow: auto;
}

.pdf-layout-mobile{
  border: solid 2px;
  height: 65vh;
  overflow: auto;
  margin: 2rem auto;
}

.pdf-document {
  display: flex;
  flex-wrap: wrap;
}

.textLayer{
  display: none !important;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}


.depositTab{
  padding: 16px;
}

.rgbaBG{
  background-color: rgba(205, 230, 223, 0.3);
}

.rgbaBG2{
  background-color: rgba(242, 242, 242, 0.5);
}

.rgbaBG3{
  background-color: rgba(253, 244, 207, 0.4);
}

html {
  overflow: scroll;
  overflow-x: hidden;
}
::-webkit-scrollbar {
  width: 0;  /* Remove scrollbar space */
  background: transparent;  /* Optional: just make scrollbar invisible */
}
.focus\\:bg-white:focus {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-inset:focus {
  --tw-ring-inset: inset;
}
.focus\\:ring-white:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 255 255 / var(--tw-ring-opacity));
}
.group:hover .group-hover\\:scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@media (prefers-color-scheme: dark) {

  .dark\\:border-\\[\\#D2D2D2\\] {
    --tw-border-opacity: 1;
    border-color: rgb(210 210 210 / var(--tw-border-opacity));
  }

  .dark\\:border-\\[\\#036C4F\\] {
    --tw-border-opacity: 1;
    border-color: rgb(3 108 79 / var(--tw-border-opacity));
  }

  .dark\\:border-\\[\\#F6C911\\] {
    --tw-border-opacity: 1;
    border-color: rgb(246 201 17 / var(--tw-border-opacity));
  }

  .dark\\:bg-\\[\\#1E1E1E\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(30 30 30 / var(--tw-bg-opacity));
  }

  .dark\\:text-black {
    --tw-text-opacity: 1;
    color: rgb(0 0 0 / var(--tw-text-opacity));
  }
}
@media (min-width: 640px) {

  .sm\\:block {
    display: block;
  }

  .sm\\:hidden {
    display: none;
  }

  .sm\\:items-stretch {
    align-items: stretch;
  }

  .sm\\:justify-start {
    justify-content: flex-start;
  }

  .sm\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}
@media (min-width: 768px) {

  .md\\:order-1 {
    order: 1;
  }

  .md\\:order-2 {
    order: 2;
  }

  .md\\:m-auto {
    margin: auto;
  }

  .md\\:mb-2 {
    margin-bottom: 0.5rem;
  }

  .md\\:mt-12 {
    margin-top: 3rem;
  }

  .md\\:mt-\\[70px\\] {
    margin-top: 70px;
  }

  .md\\:block {
    display: block;
  }

  .md\\:flex {
    display: flex;
  }

  .md\\:grid {
    display: grid;
  }

  .md\\:hidden {
    display: none;
  }

  .md\\:w-6\\/12 {
    width: 50%;
  }

  .md\\:w-8\\/12 {
    width: 66.666667%;
  }

  .md\\:w-\\[65\\%\\] {
    width: 65%;
  }

  .md\\:w-\\[50\\%\\] {
    width: 50%;
  }

  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:flex-col {
    flex-direction: column;
  }

  .md\\:justify-start {
    justify-content: flex-start;
  }

  .md\\:space-x-40 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(10rem * var(--tw-space-x-reverse));
    margin-left: calc(10rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .md\\:space-x-12 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(3rem * var(--tw-space-x-reverse));
    margin-left: calc(3rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .md\\:rounded-2xl {
    border-radius: 1rem;
  }

  .md\\:bg-\\[\\#F6F8FA\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(246 248 250 / var(--tw-bg-opacity));
  }

  .md\\:p-8 {
    padding: 2rem;
  }

  .md\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .md\\:py-8 {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .md\\:pl-\\[80px\\] {
    padding-left: 80px;
  }

  .md\\:pr-\\[80px\\] {
    padding-right: 80px;
  }

  .md\\:pt-\\[50px\\] {
    padding-top: 50px;
  }

  .md\\:pt-\\[70px\\] {
    padding-top: 70px;
  }

  .md\\:pb-\\[165px\\] {
    padding-bottom: 165px;
  }

  .md\\:text-\\[56px\\] {
    font-size: 56px;
  }

  .md\\:text-\\[20px\\] {
    font-size: 20px;
  }

  .md\\:text-\\[40px\\] {
    font-size: 40px;
  }

  .md\\:text-\\[24px\\] {
    font-size: 24px;
  }
}
@media (min-width: 1024px) {

  .lg\\:order-1 {
    order: 1;
  }

  .lg\\:order-2 {
    order: 2;
  }

  .lg\\:mb-2 {
    margin-bottom: 0.5rem;
  }

  .lg\\:mt-8 {
    margin-top: 2rem;
  }

  .lg\\:block {
    display: block;
  }

  .lg\\:flex {
    display: flex;
  }

  .lg\\:grid {
    display: grid;
  }

  .lg\\:hidden {
    display: none;
  }

  .lg\\:w-auto {
    width: auto;
  }

  .lg\\:w-6\\/12 {
    width: 50%;
  }

  .lg\\:w-8\\/12 {
    width: 66.666667%;
  }

  .lg\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:flex-row {
    flex-direction: row;
  }

  .lg\\:flex-col {
    flex-direction: column;
  }

  .lg\\:space-x-16 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(4rem * var(--tw-space-x-reverse));
    margin-left: calc(4rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .lg\\:p-8 {
    padding: 2rem;
  }

  .lg\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/css/index.css"],"names":[],"mappings":"AAAA;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,0BAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,4NAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,QAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,eAAmB;EAAnB;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gKAAmB;EAAnB,wJAAmB;EAAnB,iLAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAGnB;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;;EAEf,sBAAsB;EACtB,mCAAmC;EACnC,kCAAkC;AACpC;;AAGE;EAAA,YAAgC;EAAhC,iBAAgC;EAAhC;AAAgC;;AAGlC;EACE;aACW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,QAAQ;EACR,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,QAAQ;EACR,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,uBAAuB;EACvB,iBAAiB;EAEjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EASE,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,aAAa;AAPf;;AAUA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,UAAU;EACV,UAAU;EACV,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,YAAY;AACd;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,mBACwB,SAAS;EAC/B,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;GAEG;;AAEH;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,UAAU;;EAEV,mBAAmB;EACnB,0BAA0B;;EAE1B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,UAAU;EACV,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,UAAU;EACV,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,cAAc;EACd,6BAA6B;EAC7B,2BAA2B;EAC3B,YAAY;EACZ,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,cAAc;EACd,4BAA4B;EAC5B,2BAA2B;EAC3B,8BAA8B;EAC9B,iCAAiC;EACjC,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,0BAA0B;EAC1B,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,UAAU;;EAEV,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,qBAAqB;EACrB,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,gCAAgC;EAChC,MAAM;EACN,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB;AACF;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;;AAEhC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;;;;;;;;;;;;GAYG;;AAEH;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,UAAU;EACV,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,UAAU;EACV,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,UAAU;EACV,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,wBAAmB;EAAnB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,wBAAmB;EAAnB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,UAAU;EACV,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,UAAU;EACV,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE;wBACsB;EACtB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,UAAU;EACV,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,oCAAoC;EACpC,oBAAoB;EACpB,UAAU;EACV,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,uBAAkB;EAAlB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,UAAU;EACV,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,UAAU;EACV,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,UAAU;EACV,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,UAAU;EACV,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,uBAAkB;EAAlB,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,wBAAmB;EAAnB,mBAAmB;EACnB,SAAS;EACT,QAAQ;EACR,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,WAAW;EACX,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,UAAU;EACV,WAAW;;EAEX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,uBAAkB;EAAlB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,QAAQ;EACR,aAAa;EACb,OAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,QAAQ;EACR,aAAa;EACb,OAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;;AAGA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,yDAA+C;EAC/C,qCAAqC;EACrC,aAAa;EACb,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,kCAA6B;EAA7B,6BAA6B;EAC7B,aAAa;EACb,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yDAA+C;EAC/C,qCAAqC;EACrC,aAAa;EACb,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,yDAA+C;EAC/C,qCAAqC;EACrC,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;;;AAIA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,2CAA2C;EAC3C,UAAU;EACV,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,+CAA+C;EAC/C,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB;AACF;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,+CAA+C;EAC/C,UAAU;EACV,SAAS;EACT,mBAAmB;EACnB;AACF;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,WAAW;EACX,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,YAAY;EACZ,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,YAAY;EACZ,2BAA2B;EAC3B,2BAA2B;EAC3B;AACF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,sBAAsB;EACtB,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mBAAmB,EAAE,iCAAiC;AACxD;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B;AACF;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yDAA4C;EAC5C,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;;EAEhB,4HAA+H;AACjI;;AAEA;EACE,yDAA4D;EAC5D,qCAAqC;AACvC;;AAEA;EACE,yDAA6C;AAC/C;;AAEA;EACE,yDAA4D;AAC9D;;AAEA;EACE,yDAA4C;AAC9C;;AAEA;EACE,yDAA4D;AAC9D;;AAEA;EACE,yDAA+C;AACjD;;AAEA;EACE,yDAA6C;AAC/C;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE;AACF;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,gCAAgC;EAChC,aAAa;EACb,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,gCAAgC;EAChC,WAAW;EACX,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,wBAAmB;EAAnB,mBAAmB;EACnB,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,gDAAgD;EAChD,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,UAAU;EACV,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,UAAU,EAAE,YAAY;AAC1B;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;AACd;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,oCAAoC,4BAA4B,EAI5B,mBAAmB;EACrD,uBAAuB;AAHzB;;AAMA;EACE,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;;AAEhB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,MAAM;EACN,OAAO;EACP,UAAU;EACV,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0EAA0E;AAC5E;AACA;EACE,OAAO;EACP,SAAS;EACT,UAAU;EACV,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0EAA0E;AAC5E;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EAEE,kDAAkD;AACpD;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,UAAU;AACZ;AACA;EACE,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAaA;EACE;IAEU,wBAAwB;EAClC;EACA;IAEU,2BAA2B;EACrC;AACF;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,UAAU;EACV,UAAU;EACV,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,6BAA6B;EAC7B,0BAA0B;EAC1B,wBAAwB;EACxB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,KAAK,UAAU,EAAE;EACjB,OAAO,UAAU,EAAE;AACrB;;AAsBA;EACE,4BAA4B;EAC5B,6BAA6B;EAE7B,sBAAsB;EAEtB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;;;;;;;;;GASG;AACH;;;;;;;;;;GAUG;;AAEH;;;;EAIE;;;AAGF;;;;;;;GAOG;;AAEH;;;;;;;;;;;;;;;;;;;;;GAqBG;AACH;;;;;;;;;;;;;;;;;;;;GAoBG;;AAEH;EACE,6BAA6B;AAC/B;;AAEA;EACE;IACE,yDAA+C;IAC/C,qCAAqC;IACrC,aAAa;IACb,YAAY;EACd;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,SAAS;IACT,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;AACtB;;EAEE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,0BAA0B;IAC1B,uBAAuB;IACvB,8BAA8B;EAChC;;EAEA;IACE,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;AAClB;;EAEE;IACE,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,cAAc;IACd,yBAAiB;YAAjB,iBAAiB;IACjB,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,YAAY;IACZ,4BAA4B;IAC5B,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,QAAQ;IACR,YAAY;EACd;AACF;;AAEA;;IAEI;MACE,aAAa;IACf;EACF;;AAEF;;EAEE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;;IAEI;MACE,aAAa;IACf;EACF;;AAEF;;EAEE;IACE,aAAa;EACf;AACF;;;AAGA;;IAEI;MACE,cAAc;IAChB;;IAEA;MACE,cAAc;MACd,cAAc;MACd,yBAAiB;cAAjB,iBAAiB;MACjB,sBAAsB;MACtB,aAAa;IACf;;IAEA;MACE,sBAAsB;IACxB;;IAEA;MACE,gBAAgB;MAChB,cAAc;MACd,YAAY;MACZ,4BAA4B;MAC5B,sBAAsB;IACxB;;IAEA;MACE,YAAY;MACZ,YAAY;MACZ,UAAU;MACV,YAAY;MACZ,kBAAkB;MAClB,gBAAgB;MAChB,eAAe;MACf,iBAAiB;MACjB,cAAc;IAChB;;IAEA;MACE,gBAAgB;MAChB,gBAAgB;IAClB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,WAAW;IACb;EACF;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,UAAU;IACV,WAAW;IACX,oBAAoB;IACpB,yBAAyB;IACzB,wFAAwF;IACxF,kBAAkB;IAClB,WAAW;IACX,OAAO;EACT;EACA;IACE,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,eAAe;EACjB;;EAEA,qBAAqB;EACrB;IACE,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,MAAM;IACN,4BAA4B;IAC5B,qBAAqB;EACvB;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,MAAM;IACN,4BAA4B;IAC5B,qBAAqB;EACvB;;EAEA;IACE;MACE,MAAM;IACR;IACA;MACE,SAAS;IACX;IACA;MACE,WAAW;IACb;IACA;;OAEG;EACL;;AAEF;;;;;GAKG;;AAEH;EAEE,qBAAqB;AACvB;;AAEA;EAEE,oBAAoB;AACtB;;AAEA;EAEE,sBAAsB;AACxB;;AAEA;EAEE,mBAAmB;AACrB;;AAiBA;EACE,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe,EAAE,YAAY;AAC/B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,QAAQ;EACR,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,2BAA2B;EAC3B,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;AACf;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,iDAA4C;EAC5C,kBAAkB;EAClB,eAAe;;AAEjB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;;AAGA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,6BAA6B;EAC7B,gCAAgC;EAChC,2BAA2B;EAC3B,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,8BAA8B;EAC9B,iCAAiC;EACjC,2BAA2B;EAC3B,iBAAiB;EACjB,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;;AAEhB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,oCAAoC;EACpC,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,oCAAoC;EACpC,yBAAyB;EACzB,mBAAmB;;AAErB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB;AACF;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,UAAU;EACV,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kCAA6B;EAA7B,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,gCAAgC;AAChC;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,0DAAiD;EACjD,wBAAwB;EACxB,4BAA4B;AAC9B;;;AAGA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,0DAAiD;EACjD,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,6BAA6B;EAC7B,SAAS;EACT,aAAa;EACb,8DAA8D;AAChE;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,8BAA8B;EAC9B,6BAA6B;EAC7B,SAAS;EACT,aAAa;EACb,8DAA8D;AAChE;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,SAAS;;EAET,gFAAgF;EAChF,2BAA2B;EAC3B,yBAAyB;EACzB,2BAA2B;EAC3B,2BAA2B;EAC3B,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;;AAExB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAIlB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;;AAExB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAIlB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;;AAGA;;IAEI,wBAAwB;IACxB,SAAS;AACb;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,cAAc;EACd,yBAAiB;UAAjB,iBAAiB;EACjB,4BAA4B;EAC5B,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,0BAA0B;AAC5B;;;AAGA;EACE,aAAa;AACf;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,QAAQ,GAAG,2BAA2B;EACtC,uBAAuB,GAAG,4CAA4C;AACxE;AArpJA;EAAA,kBAqpJC;EArpJD;AAqpJC;AArpJD;EAAA,8BAqpJC;EArpJD;AAqpJC;AArpJD;EAAA,2GAqpJC;EArpJD,yGAqpJC;EArpJD;AAqpJC;AArpJD;EAAA;AAqpJC;AArpJD;EAAA,oBAqpJC;EArpJD;AAqpJC;AArpJD;EAAA,eAqpJC;EArpJD,eAqpJC;EArpJD;AAqpJC;AArpJD;;EAAA;IAAA,sBAqpJC;IArpJD;EAqpJC;;EArpJD;IAAA,sBAqpJC;IArpJD;EAqpJC;;EArpJD;IAAA,sBAqpJC;IArpJD;EAqpJC;;EArpJD;IAAA,kBAqpJC;IArpJD;EAqpJC;;EArpJD;IAAA,oBAqpJC;IArpJD;EAqpJC;AAAA;AArpJD;;EAAA;IAAA;EAqpJC;;EArpJD;IAAA;EAqpJC;;EArpJD;IAAA;EAqpJC;;EArpJD;IAAA;EAqpJC;;EArpJD;IAAA,oBAqpJC;IArpJD;EAqpJC;;EArpJD;IAAA,mBAqpJC;IArpJD;EAqpJC;AAAA;AArpJD;;EAAA;IAAA;EAqpJC;;EArpJD;IAAA;EAqpJC;;EArpJD;IAAA;EAqpJC;;EArpJD;IAAA;EAqpJC;;EArpJD;IAAA;EAqpJC;;EArpJD;IAAA;EAqpJC;;EArpJD;IAAA;EAqpJC;;EArpJD;IAAA;EAqpJC;;EArpJD;IAAA;EAqpJC;;EArpJD;IAAA;EAqpJC;;EArpJD;IAAA;EAqpJC;;EArpJD;IAAA;EAqpJC;;EArpJD;IAAA;EAqpJC;;EArpJD;IAAA;EAqpJC;;EArpJD;IAAA;EAqpJC;;EArpJD;IAAA;EAqpJC;;EArpJD;IAAA;EAqpJC;;EArpJD;IAAA;EAqpJC;;EArpJD;IAAA;EAqpJC;;EArpJD;IAAA,uBAqpJC;IArpJD,qDAqpJC;IArpJD;EAqpJC;;EArpJD;IAAA,uBAqpJC;IArpJD,oDAqpJC;IArpJD;EAqpJC;;EArpJD;IAAA;EAqpJC;;EArpJD;IAAA,kBAqpJC;IArpJD;EAqpJC;;EArpJD;IAAA;EAqpJC;;EArpJD;IAAA,oBAqpJC;IArpJD;EAqpJC;;EArpJD;IAAA,iBAqpJC;IArpJD;EAqpJC;;EArpJD;IAAA;EAqpJC;;EArpJD;IAAA;EAqpJC;;EArpJD;IAAA;EAqpJC;;EArpJD;IAAA;EAqpJC;;EArpJD;IAAA;EAqpJC;;EArpJD;IAAA;EAqpJC;;EArpJD;IAAA;EAqpJC;;EArpJD;IAAA;EAqpJC;;EArpJD;IAAA;EAqpJC;AAAA;AArpJD;;EAAA;IAAA;EAqpJC;;EArpJD;IAAA;EAqpJC;;EArpJD;IAAA;EAqpJC;;EArpJD;IAAA;EAqpJC;;EArpJD;IAAA;EAqpJC;;EArpJD;IAAA;EAqpJC;;EArpJD;IAAA;EAqpJC;;EArpJD;IAAA;EAqpJC;;EArpJD;IAAA;EAqpJC;;EArpJD;IAAA;EAqpJC;;EArpJD;IAAA;EAqpJC;;EArpJD;IAAA;EAqpJC;;EArpJD;IAAA;EAqpJC;;EArpJD;IAAA;EAqpJC;;EArpJD;IAAA;EAqpJC;;EArpJD;IAAA;EAqpJC;;EArpJD;IAAA,uBAqpJC;IArpJD,oDAqpJC;IArpJD;EAqpJC;;EArpJD;IAAA;EAqpJC;;EArpJD;IAAA,kBAqpJC;IArpJD;EAqpJC;AAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,900;1,100;1,700&display=swap');\n\nhtml,\nbody {\n  margin: 0px;\n  height: 100%;\n}\n\nbody {\n  /* margin: 0; */\n  \n  font-family: 'Poppins';\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.container {\n  @apply m-auto max-w-screen-xl p-4\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n.color-white {\n  color: #ebd8d0;\n}\n\n.two {\n  /* background: #ff8e71; */\n  height: 100%;\n  font-size: 5.5vh;\n  color: #ebd8d0;\n  margin-top: 8vh;\n}\n\n.inline-flex {\n  display: inline-flex;\n}\n\n.currency-position{\n  text-align: right;\n  margin-right: 0.5rem;\n}\n\n.cal-padding-position{\n  padding: 0rem 1rem;\n}\n\n.investment-input-width{\n  margin-top: 0.8rem;\n  text-align: left !important;\n}\n\n.frame-bg{\n  background-color: #FEF8E0;\n}\n\n.eligible-text{\n  font-weight: 400;\n  font-size: 16px;\n}\n\n.eligible-text-mob-alt{\n  font-weight: 400;\n  font-size: 8px;\n}\n\n.eligible-text-mob{\n  font-weight: 400;\n  font-size: 10px;\n}\n\n.eligible-img{\n  width: 100px;\n  height: 100px;\n}\n\n.eligible-img-mob{\n  width: 35px;\n  height: 35px;\n}\n\n.eligible-header{\n  font-family: 'Poppins';\n  font-size: 48px;\n  font-weight: 600;\n}\n\n.eligible-header-mob{\n  font-family: 'Poppins';\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.investment-input-width-mobile{\n  margin-top: 0.5rem;\n  text-align: left !important;\n}\n\n.investment-width{\n  width: 500px !important;\n}\n\n.invest-drop-size{\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n  color: #434343;\n}\n\n.inline {\n  display: inline-block;\n}\n\n.thumbs {\n  right: 0;\n  position: absolute;\n  bottom: 0;\n  z-index: 1;\n}\n\n.thumbs-2 {\n  right: 0;\n  position: absolute;\n  bottom: 0;\n  z-index: 1;\n}\n\n.cal-amount-truncate{\n  width: 11rem !important;\n  text-align: left !important;\n}\n\n.cal-element-width{\n  width: 10rem !important;\n}\n\n.card-button-main {\n  z-index: 4;\n  color: #FFFFFF;\n  background: transparent;\n  border: solid 1px;\n  margin-top: 2rem;\n  margin-left: 2rem;\n  margin-top: 2rem;\n}\n\n.card-button {\n  width: fit-content;\n}\n\n.card-button-welfare {\n  width: fit-content;\n}\n\n.pension-button {\n  width: 10rem;\n  margin-left: 24rem;\n  z-index: 4;\n  background: #133B69;\n  border: solid;\n}\n\n.pension-button {\n  width: 10rem;\n  margin-left: 24rem;\n  z-index: 4;\n  background: #133B69;\n  border: solid;\n}\n\n.accordion-width{\n  width: 120vh;\n}\n\n.mobile-element-sub-header{\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 36px;\n  text-align: center;\n  color: #133B69;\n}\n\n.prod-details-header{\n  font-family: 'Poppins';\n  font-size: 20px;\n  font-weight: 600;\n  color: #434343;\n}\n\n.prod-details-sub-alt{\n  width: 100% !important;\n}\n\n.prod-textbox{\n  color: #434343;\n  font-size: 32px;\n  font-weight: 600;\n}\n\n.prod-textbox-bg{\n  background: #FFFEF8;\n  padding: 0.5rem;\n}\n\n.prod-cal-button{\n  background: #434343;\n  color: #fff;\n  border-radius: 15px;\n}\n\n.prod-cal-button-text{\n  font-family: 'Poppins';\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.prod-details-sub{\n  width: 400px;\n  font-size: 14px;\n  font-weight: 400;\n  color: #434343;\n}\n\n.prod-details-sub-mob{\n  width: 300px;\n  font-size: 14px;\n  font-weight: 400;\n  color: #434343;\n}\n\n.loan-calculator-card{\n  border: solid 1px #F2F2F280;\n  border-radius: 15px;\n  padding: 2rem;\n}\n\n.step-3-w{\n  width: 390px;\n}\n\n.mobile-element-sub-p{\n  /* width: 343px; */\n  /* height: 72px; */\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n  color: #434343;\n}\n\n.mobile-element-header{\n  /* width: 263px; */\n  height: 72px;\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 36px;\n  color: #133B69;\n}\n\n.element-header-altered{\n  color: #404040 !important;\n  font-size: 30px !important;\n  height: auto !important;\n  line-height: normal !important;\n}\n\n.element-header{\n  /* width: 568px; */\n  height: 60px;\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 40px;\n  line-height: 60px;\n  text-align: center;\n  color: #133B69;\n}\n\n.element-header-alt{\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 36px;\n  text-align: center;\n  color: #133B69;\n}\n\n.element-faq-sub{\n  width: 333px;\n  height: 24px;\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n  text-align: center;\n  color: #696969;\n}\n\n.element-faq-header{\n  width: 303px;\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 32px;\n  line-height: 48px;\n  text-align: center;\n  color: #133B69; \n}\n\n.element-p{\n  width: 538px;\n  height: 60px;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 30px;\n  text-align: center;\n  color: #696969;\n  flex: none;\n  flex-grow: 0;\n}\n\n.accordion-header{\n  width: 568px;\n  height: 60px;\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 40px;\n  line-height: 60px;\n  text-align: center;\n  color: #133B69;\n}\n\n.accordion-p{\n  width: 538px;\n  height: 60px;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 30px;\n  text-align: center;\n  color: #696969;\n  flex: none;\n  flex-grow: 0;\n}\n\n.disclaimer-bubble-alt{\n  height: 125px;\n  left: 16px;\n  top: 936px;\n  background: rgba(253, 244, 207, 0.31);\n  border-radius: 16px;\n}\n\n.accordion-p-alt{\n  height: 60px;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 30px;\n  text-align: center;\n  color: #696969;\n  flex: none;\n  flex-grow: 0;\n}\n\n.loan-account {\n  top: 100rem;\n  width: 100%;\n  /* height: 90vh; */\n  /* background: #D1DAE5; */\n}\n\n.bubble-font-size{\n  font-size: 10px !important;\n}\n\n.pension-account {\n  top: 100rem;\n  width: 100%;\n  /* height: -webkit-fill-available; */\n  background: #d1dae52e;\n}\n\n.mobile-info-card-p {\n  font-size: 20px !important;\n  width: auto !important;\n}\n\n.loan-step-p{\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n  text-align: center;\n  color: #696969;\n}\n\n.not_found_text{\n  width: 136px;\n  height: 20px;\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 20px;\n  color: #FFFFFF;\n}\n\n.not_found_image{\n  margin: 5rem 0rem;\n}\n\n.not_found_button{\n  margin-top: 3rem;\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  padding: 16px 24px;\n  gap: 10px;\n  width: 184px;\n  height: 52px;\n  background: #17477E;\n  border-radius: 8px;\n}\n\n.not_found_heading{\n  margin-bottom: 2rem;\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 56px;\n  line-height: 84px;\n  color: #434343;\n  flex: none;\n}\n\n.not_found_margin{\n  margin: 10rem 0rem;\n}\n\n.not_found_p{\n  width: 336px;\n  height: 60px;\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 30px;\n  color: #434343;\n}\n\n.info-card-p {\n  width: 270px;\n  z-index: 98;\n  height: 36px;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 36px;\n  color: #FFFFFF;\n  flex: none;\n  order: 0;\n  flex-grow: 0;\n  margin-left: 2rem;\n  margin-top: 2rem;\n}\n\n.mobile-info-card-p-2 {\n  font-size: 12px !important;\n  width: auto !important;\n}\n\n.info-card-p-2 {\n  height: 36px;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n  color: #FFFFFF;\n  flex: none;\n  order: 0;\n  flex-grow: 0;\n  margin-left: 2rem;\n  margin-top: 2rem;\n  z-index: 3;\n}\n\n.info-card-img {\n  margin-top: 1.6rem;\n}\n\n.mobile-info-card-img {\n  margin-top: 0.8rem;\n  width: 3rem;\n}\n\n.loan-button {\n  width: 10rem;\n  margin-left: 18rem;\n  z-index: 4;\n  background: #133B69;\n  border: solid;\n}\n\n.loan-step-1-color {\n  color: #CDA70E;\n}\n\n.loan-step-2-color {\n  color: #036C4F;\n}\n\n.loan-step-3-color {\n  color: #133B69;\n}\n\n.input-container {\n  display: -ms-flexbox; /* IE10 */\n  display: flex;\n  width: 100%;\n  margin-bottom: 15px;\n}\n\n.button-padding {\n  padding: 16px 32px !important;\n}\n\n.cal-drop-icon{\n  height: 9px;\n  /* margin-top: 6px; */\n  margin-left: 5px;\n}\n\n.learn-display {\n  display: inline-flex;\n}\n\n.partner-img-alt{\n  width: 14rem !important;\n  height: 6rem !important;\n}\n\n.partner-img-alt-m{\n  width: 14rem !important;\n  height: 4.5rem !important;\n}\n\n.mobile-s-img{\n  padding: 0.17rem;\n}\n\n.mobile-s-img-alt{\n  padding: 0.3rem;\n}\n\n.mobile-ec-img{\n  padding: 0rem 0.4rem;\n}\n\n.partner-img-alt-2{\n  padding: 0.5rem;\n}\n\n.menu-drop-icon-alt-m{\n  margin-left: 9rem !important;\n}\n\n.mobile-contact-box {\n  margin: auto;\n  width: 95%;\n  background: #FFFFFF;\n  box-shadow: 0px 24px 155px rgba(0, 0, 0, 0.08);\n  border-radius: 16px;\n}\n\n.contact-box {\n  width: 922px;\n  /* height: 692px; */\n  left: 0px;\n  top: 0px;\n  background: #FFFFFF;\n  box-shadow: 0px 24px 155px rgba(0, 0, 0, 0.08);\n  border-radius: 16px;\n}\n\n.contact-dropdown {\n  border: 0.6px solid #434343;\n  border-radius: 8px;\n  width: 318px;\n  height: 60px;\n}\n\n.send-button {\n  padding: 0rem 5rem;\n  margin-top: 4rem;\n}\n\n.send-p {\n  display: inline-flex;\n}\n\n.bu-send {\n  margin-top: auto;\n  margin-bottom: auto;\n  margin-left: 5px;\n}\n\n.contact-area {\n  padding: 0rem 45px;\n}\n\n.phone-app-ava{\n  width: 2rem;\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: 3vh;\n}\n\n.phone-short-code {\n  width: 27.31px;\n  height: 54px;\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: 1vh;\n}\n\n.freq-text{\n  font-size: 19px;\n  border: none;\n  font-weight: 500;\n  box-shadow: none;\n}\n\n.freq-text-alt{\n  font-size: 14px;\n  border: none;\n  box-shadow: none;\n}\n\n.list-10{\n  padding-left: 1rem !important;\n}\n\n.cal-drop-button-width{\n  /* width: 22vh !important; */\n  width: 16vh !important;\n}\n\n.cal-drop-button-width-alt{\n  width: 12vh !important;\n}\n\n/* .cal-drop-button-width-alt{\n  width: 15vh !important;\n} */\n\n.drop-down-item-text{\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 20px;\n  line-height: 24px;\n  color: #434343;\n}\n\n.arrow-width{\n  width: 15px !important;\n  margin-left: 1rem;\n}\n\n.card-verify-icon-alt{\n  width: 35px;\n  height: 30px;\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: 1vh;\n}\n\n.phone-short-code-alt {\n  width: 16.97px;\n  height: 32.04px;\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: 1vh;\n}\n\n.mobile-short-code{\n  /* width: 53px; */\n  height: 30px;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 30px;\n  text-align: center;\n  color: #0A0A0A;\n}\n\n.card-verify-icon{\n  width: 75px;\n  height: 55px;\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: 1vh;\n}\n\n.short-code {\n  width: 74px;\n  height: 36px;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 36px;\n  color: #0A0A0A;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.hr-header {\n  width: 25rem;\n}\n\n.scan-code {\n  width: 408px;\n  height: 60px;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 30px;\n  color: #696969;\n}\n\n.phone-text {\n  width: 92px;\n  height: 24px;\n  font-style: normal;\n  text-align: center;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 14px;\n  color: #0A0A0A;\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: 1vh;\n}\n\n.home-card-loan{\n  margin-left: -10vh;\n  margin-top: -3vh;\n}\n\n.barcode-ring {\n  width: 135px;\n  height: 135px;\n  left: 100px;\n  top: 638px;\n\n  background: #FFFFFF;\n  /* Primary color/blue/04 */\n\n  border: 2px solid #133B69;\n  border-radius: 16px;\n}\n\n.mobile-card-icon-ring-text {\n  width: 85px;\n  height: 54.19px;\n  left: 13px;\n  top: 324.31px;\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 11px;\n  text-align: center;\n  color: #0A0A0A;\n}\n\n.mobile-app-ring-text{\n  width: 85px;\n  height: 54.19px;\n  left: 13px;\n  top: 324.31px;\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 20px;\n  text-align: center;\n  color: #0A0A0A;\n}\n\n.mobile-app-ring{\n  width: 88px;\n  height: 88px;\n  left: 12px;\n  top: 319px;\n  background: #FFFFFF;\n  border: 1px solid #0A0A0A;\n  border-radius: 16px;\n}\n\n.app-ring {\n  width: 125px;\n  height: 135px;\n  background: #FFFFFF;\n  border: 2px solid #000;\n  border-radius: 16px;\n}\n\n.dial-ring-color-alt{\n  border: 2px solid #036C4F !important;\n}\n\n.mobile-dial-ring-alt{\n  border: 2px solid #036C4F !important;\n}\n\n.verify-card-box{\n  border: 2px solid #D2D2D2;\n  padding: 1.5rem;\n  border-radius: 15px;\n}\n\n.verify-card-box-alt{\n  border: 2px solid #2E977A !important;\n  background-color: #fff !important;\n}\n\n.mobile-dial-ring{\n  width: 88px;\n  height: 88px;\n  left: 116px;\n  top: 319px;\n  background: #FFFFFF;\n  border: 1px solid #F6C911;\n  border-radius: 16px;\n}\n\n.dial-ring {\n  width: 135px;\n  height: 135px;\n  background: #FFFFFF;\n  border: 2px solid #F6C911;\n  border-radius: 16px;\n}\n\n.mobile-contact-input-area {\n  height: 160px;\n  width: 40vh;\n  border: 0.6px solid #434343;\n}\n\n.contact-input-area {\n  height: 160px;\n  width: 46rem;\n  border: 0.6px solid #434343;\n}\n\n.contact-input-phone {\n  display: inline-flex;\n  width: 3rem;\n  color: #133B69;\n  border-right: none !important;\n  border: 0.6px solid #434343;\n  height: 56px;\n  border-top-left-radius: 8.6px;\n  border-bottom-left-radius: 8.6px;\n}\n\n.contact-input-number {\n  display: inline-flex;\n  width: 3rem;\n  color: #133B69;\n  border-left: none !important;\n  border: 0.6px solid #434343;\n  border-top-right-radius: 8.6px;\n  border-bottom-right-radius: 8.6px;\n  height: 56px;\n  width: 275px;\n}\n\n.contact-input {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  padding: 16px 72px 16px 8px;\n  gap: 8px;\n  width: 318px;\n  height: 56px;\n  background: #FFFFFF;\n  border: 0.6px solid #434343;\n  border-radius: 8px;\n  flex: none;\n  /* order: 1; */\n  align-self: stretch;\n  flex-grow: 0;\n}\n\n.goals-img-ht {\n  margin-top: -1rem;\n  width: 13rem;\n}\n\n.mobile-define-box {\n  margin: 10px auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 15px 43px;\n  gap: 14px;\n  width: 156px;\n  height: 148px;\n  background: #FFFFFF;\n  box-shadow: 0px 48px 80px rgba(0, 0, 0, 0.05);\n  border-radius: 16px;\n}\n\n.define-box {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 15px 43px;\n  gap: 14px;\n  width: 210px;\n  height: 198px;\n  background: #FFFFFF;\n  box-shadow: 0px 48px 80px rgba(0, 0, 0, 0.05);\n  border-radius: 16px;\n}\n\n.mobile-about-img {\n  margin: auto;\n  width: 100px;\n  height: 100px;\n  border-radius: 50%;\n}\n\n.about-header{\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 56px;\n  line-height: 84px;\n  text-align: center;\n  color: #133B69;\n}\n\n.choice-card-text{\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 24px;\n  color: #FFFFFF;\n}\n\n.choice-card-img{\n  width:18px;\n  height:19.21px\n}\n\n.choice-card-button{\n  display: flex;\n  justify-content: center;\n  flex-direction: row;\n  align-items: center;\n  padding: 10px 24px;\n  gap: 7px;\n  width: 129px;\n  height: 45px;\n  background: #133B69;\n  border-radius: 8px;\n}\n\n.page-heading-selected{\n  text-decoration-color: #133B69 !important;\n  color: #133B69 !important;\n}\n\n.page-heading{\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 30px;\n  text-decoration: underline;\n  text-underline-offset: 8px;\n  text-decoration-color: #B4B4B4;\n  color: #B4B4B4;\n}\n\n.freq-card-button-selected-text{\n  color: #fff;\n}\n\n.freq-card-button-selected{\n  display: flex;\n  justify-content: center;\n  flex-direction: row;\n  align-items: flex-start;\n  padding: 10px 24px;\n  gap: 8px;\n  background: #133B69;\n  border-radius: 8px;\n}\n\n.freq-card-button{\n  display: flex;\n  justify-content: center;\n  flex-direction: row;\n  align-items: flex-start;\n  padding: 10px 24px;\n  gap: 8px;\n  background: #EDEDED;\n  border-radius: 8px;\n}\n\n.main-right-padding{\n  padding: 0rem 5rem;\n}\n\n.main-padding{\n  padding: 2rem 0rem;\n}\n\n.team-main-padding{\n  padding: 0rem 11rem;\n}\n\n.swirl-neg-margin{\n  margin-top: -1.5rem;\n}\n\n.phones-img-width{\n  width: 35rem;\n}\n\n.phones-side-width{\n  height: 31rem;\n  margin: 2rem 0rem;\n}\n\n.team-header-margin{\n  margin-left: -4rem;\n  margin-bottom: 3rem;\n}\n\n.team-padding{\n  padding: 0rem 3rem;\n}\n\n.partner-padding{\n  padding: 0rem 5rem;\n}\n\n.partner-name-alt{\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n  color: #17477E;\n  text-align: center;\n}\n\n.faq-button-text{\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 30px;\n  color: #FFFFFF;\n}\n\n.faq-button{\n  /* z-index: 999; */\n  position: relative;\n  justify-content: center;\n  align-items: center;\n  padding: 16px 32px;\n  gap: 10px;\n  width: 202px;\n  height: 62px;\n  background: #17477E;\n  border-radius: 8px;\n}\n\n.partner-img-with-mobile{\n  width: 20rem;\n}\n\n.partner-name-alt-mobile{\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 10px;\n  line-height: 20px;\n  color: #133B69;\n}\n\n.swirl-padding{\n  margin-right: 8rem;\n}\n\n.team-name{\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 36px;\n  color: #434343;\n  text-align: center;\n  margin: auto;\n}\n\n.team-role{\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n  color: #696969;\n  text-align: center;\n}\n\n.about-sub{\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 20px;\n  line-height: 30px;\n  text-align: center;\n  color: #696969;\n}\n\n.about-sub-alt{\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 30px;\n  color: #696969;\n}\n\n.about-img-alt{\n  width: 957px;\n  height: 424px;\n  left: 241px;\n  top: 690px;\n\n  background: rgba(217, 217, 217, 0.2);\n  border-radius: 58px;\n}\n\n.about-img {\n  width: 240px;\n  height: 240px;\n  border-radius: 50%;\n}\n\n.business-info {\n  width: 816px;\n  height: 278.79px;\n  background: #395b9f2b;\n  box-shadow: 0px 48px 80px rgba(0, 0, 0, 0.05);\n  border-radius: 16px;\n}\n\n.mobile-business-info {\n  margin: auto;\n  width: 95%;\n  background: #395b9f2b;\n  box-shadow: 0px 48px 80px rgba(0, 0, 0, 0.05);\n  border-radius: 16px;\n}\n\n.place-x {\n  float: right;\n}\n\n.mobile-nav-text {\n  /* width: 81px; */\n  height: 30px;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 30px;\n  color: #FFFFFF;\n  flex: none;\n  order: 0;\n  flex-grow: 0;\n  margin-bottom: 32px;\n}\n\n.mobile-nav-bg {\n  background: #133B69;\n  height: 650px;\n  border-radius: 0px 0px 40px 40px;\n  top: 0;\n  position: absolute;\n  width: -webkit-fill-available;\n}\n\n.mobile-menu-drop-icon {\n  width: 25px;\n  height: 20px;  \n  margin-top: 6px;\n  margin-left: 5px;\n}\n\n.cal-drop-icon-alt{\n  width: 25px;\n  height: 25px;\n  margin-top: 20px;\n  margin-left: 30px;\n  cursor: pointer;\n}\n\n.menu-drop-icon {\n  width: 25px;\n  height: 15px;  \n  margin-top: 6px;\n  margin-left: 5px;\n}\n\n.register-position {\n  margin-left: -1rem;\n  margin-top: 2rem;\n}\n\n.mobile-menu-bar {\n  margin-left: -5.2rem;\n  width: max-content;\n  line-height: 2rem;\n  margin-top: 2rem\n}\n\n.mobile-dropdown-text {\n  height: 30px;\n  left: 0px;\n  top: 76px;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 20px;\n  line-height: 30px;\n  color: #B2C2D4;\n}\n\n.frequency-display{\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n  color: #434343;\n}\n\n.menu-bar-alt{\n  margin-top: auto !important;\n  width: 21rem !important;\n  height: auto !important;\n}\n\n.menu-bar {\n  background: white;\n  width: 14rem;\n  padding: 1rem;\n  line-height: 2rem;\n  box-shadow: 1px 2px 7px 0px #afafd46b;\n  border-radius: 5px;\n  margin-top: 2rem\n}\n\n.icon {\n  padding: 1rem;\n  background: #D1DAE5;\n  color: #133B69;\n  min-width: 100px;\n  text-align: center;\n  border-radius: 8px 0px 0px 8px;\n\n}\n\n.input-field {\n  width: 100%;\n  padding: 10px;\n  outline: none;\n  color: #133B69;\n  font-weight: 400;\n  font-size: 24px;\n  line-height: 36px;\n  background-color: #d1dae536;\n}\n\n.portfolio-cal {\n  width: 647px;\n  padding: 3rem 8rem;\n  background: #FFFFFF;\n  box-shadow: 4px 3px 40px rgba(0, 0, 0, 0.07);\n  border-radius: 16px;\n}\n\n.mobile-portfolio-cal {\n  width: 95%;\n  background: #FFFFFF;\n  box-shadow: 4px 3px 40px rgba(0, 0, 0, 0.07);\n  border-radius: 16px;\n}\n\n.mobile-apply-button{\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 16px 32px;\n  gap: 10px;\n  width: 343px;\n  height: 56px;\n  background: #17477E;\n  border-radius: 8px;\n  flex: none;\n  flex-grow: 0;\n}\n\n/* .apply-now-button {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 16px 32px;\n  gap: 10px;\n  width: 237px;\n  height: 56px;\n  border-radius: 8px;\n  color: #17477E\n} */\n\n.element-pension-w{\n  width: 527px !important;\n}\n\n.element-in-steps {\n  width: 274px;\n  height: 120px;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 40px;\n  line-height: 60px;\n  color: #133B69;\n  flex: none;\n  order: 0;\n  flex-grow: 0;\n}\n\n.pension-w{\n  width: 452px !important;\n}\n\n.element-in-steps-p {\n  width: 331px;\n  /* height: 90px; */\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 30px;\n  color: #696969;\n  flex: none;\n  flex-grow: 0;\n}\n\n.loan-step-button {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  margin-bottom: 1rem;\n  padding: 12px 24px;\n  gap: 10px;\n  width: 100px;\n  height: 46px;\n  border-radius: 40px;\n  flex: none;\n  order: 0;\n  flex-grow: 0;\n}\n\n.loan-step-1 {\n  background: #FDF4CF;\n}\n\n.loan-step-2 {\n  background: #CDE6DF;\n}\n\n.loan-step-3 {\n  background: #D1DAE5;\n}\n\n.mobile-info-card-sm {\n  width: 72px;\n  height: 72px;\n  border-radius: 70px;\n  margin-left: 2rem;\n  margin-top: 2rem;\n  background: #FFFFFF;\n}\n\n.info-card-sm {\n  /* position: absolute; */\n  width: 135px;\n  height: 135px;\n  margin-left: 2rem;\n  margin-top: 2rem;\n  border-radius: 70px;\n  background: #FFFFFF;\n}\n\n.loan-p {\n  width: 232px;\n  height: 96px;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n  color: #696969;\n}\n\n.welfare-p {\n  width: 271px;\n  height: 144px;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n  color: #696969;\n  flex: none;\n  order: 1;\n  flex-grow: 0;\n}\n\n.welfare-insurance-card{\n  width: 480px;\n  height: 417.83px;\n  border-radius: 13px;\n}\n\n.welfare-insurance-card-1{\n  background-color: #2E977A;\n}\n\n.welfare-insurance-card-2{\n  background-color: #03573F;\n}\n\n.mobile-pension-card-1 {\n  width: 95%;\n  height: fit-content;\n  background-color: #17477E;\n  border-radius: 13px;\n  margin: auto;\n}\n\n.mobile-welfare-card-1 {\n  width: 95%;\n  height: fit-content;\n  border-radius: 13px;\n  margin: auto;\n}\n\n.pension-card-1 {\n  width: 480px;\n  height: 417.83px;\n  background-color: #17477E;\n  border-radius: 13px;\n}\n\n.pension-card-2 {\n  width: 480px;\n  height: 417.83px;\n  background-color: #133B69;\n  border-radius: 13px;\n}\n\n.box {\n  height: 45px;\n  overflow: hidden;\n  position: relative;\n  display: inline-block;\n}\n\n.box-mobile {\n  height: 25px;\n  overflow: hidden;\n  position: relative;\n  display: inline-block;\n}\n\n.barcode-bg {\n  border-color: #355f90;\n  width: 13rem;\n}\n\n.request-text {\n  width: 354px;\n  height: 96px;\n  left: 71px;\n  bottom: 53px;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 32px;\n  line-height: 48px;\n  color: #FFFFFF;\n}\n\n.text-width-2 {\n  width: 318px;\n  height: 90px;\n}\n\n.text-width {\n  width: 404px;\n  height: 90px;\n}\n\n.landing-img-third{\n  width: 70vh;\n}\n\n.landing-img-fourth{\n  width: 80vh;\n}\n\n.landing-text-color {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 20px;\n  line-height: 30px;\n  color: #696969;\n  flex: none;\n  order: 1;\n  flex-grow: 0;\n}\n\n.register-p{\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 30px;\n  color: #696969;\n  flex: none;\n  order: 1;\n  flex-grow: 0;\n}\n\n.landing-text-position {\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: 18vh;\n  margin-bottom: auto;\n}\n\n.swirl-position{\n  margin: -6rem 25rem;\n  width: 9rem;\n}\n\n.step-1-item{\n  margin-left: 3rem;\n  margin-top: 18rem;\n}\n\n.landing-img-position {\n  /* width: 95vh;\n  margin-left: -10rem; */\n  width: 120vh;\n  margin-left: -19rem;\n}\n\n.steps-text {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 20px;\n  line-height: 30px;\n  color: #133B69;\n  flex: none;\n  order: 0;\n  flex-grow: 0;\n}\n\n.last-goal-item{\n  width: 238px;\n  height: 40px;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 20px;\n  color: #133B69;\n  flex: none;\n  flex-grow: 0;\n}\n\n.steps-button {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  margin-bottom: 1rem;\n  padding: 8px 24px;\n  gap: 10px;\n  width: 111px;\n  height: 46px;\n  background: rgba(209, 218, 229, 0.5);\n  border-radius: 374px;\n  flex: none;\n  order: 0;\n  flex-grow: 0;\n}\n\n.button-margin-left{\n  margin-left: auto;\n}\n\n.landing-img {\n  width: 115vh;\n}\n\n.swirl-2-position{\n  margin: 0rem 8rem;\n}\n\n.step-2-element{\n  position: absolute;\n  bottom: 10rem;\n  right: 6rem;\n}\n\n.register-header{\n  font-style: normal;\n  font-weight: 600;\n  font-size: 32px;\n  line-height: 48px;\n  color: #133B69;\n}\n\n.register-para{\n  font-style: normal;\n  font-weight: 500;\n  font-size: 20px;\n  line-height: 30px;\n  color: #696969;\n}\n\n.partner-border{\n  border: solid 2px #D1DAE5;\n  width: fit-content;\n  border-radius: 15px;\n  padding: 8px;\n}\n\n.partner-text{\n  font-family: 'Poppins';\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 24px;\n  text-align: left;\n  color: #696969;\n}\n\n.partner-text-alt {\n  font-family: 'Poppins';\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 16px;\n  text-align: left;\n  color: #696969;\n}\n\n.top-text {\n  /* width: 98px; */\n  height: 30px;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 30px;\n  color: #FFFFFF;\n  flex: none;\n  order: 0;\n  flex-grow: 0;\n}\n\n.apply-now-text {\n  /* width: 80px; */\n  height: 24px;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 24px;\n  color: #FFFFFF;\n  flex: none;\n  order: 0;\n  flex-grow: 0;\n}\n\n.apply-now-button-alt{\n  margin-left: 24rem !important;\n}\n\n.apply-now-button {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  padding: 16px 32px;\n  gap: 10px;\n  width: 144px;\n  height: 56px;\n  background: #133B69;\n  border-radius: 8px;\n  flex: none;\n  order: 2;\n  margin-top: 2rem;\n  margin-left: 18rem;\n  flex-grow: 0;\n}\n\n.top-button {\n  /* display: flex; */\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 16px 32px;\n  gap: 4px;\n  /* width: 190px; */\n  height: 62px;\n  background: #133B69;\n  border-radius: 8px;\n  flex: none;\n  order: 1;\n  flex-grow: 0;\n}\n\n.register-text{\n  width: 46px;\n  height: 20px;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 20px;\n  color: #133B69;\n  flex: none;\n  order: 0;\n  flex-grow: 0;\n}\n\n.register-button {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  padding: 16px 24px;\n  gap: 10px;\n  width: 94px;\n  height: 52px;\n  background: #fff;\n  border-radius: 8px;\n}\n\n.nav-agent-button-text{\n  color: #17477E;\n  font-weight: 600;\n}\n\n.button-text {\n  width: 142px;\n  height: 24px;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 13px;\n  line-height: 24px;\n  color: #FFFFFF;\n  flex: none;\n  order: 0;\n  flex-grow: 0;\n}\n\n.nav-agent-button{\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  padding: 16px 32px;\n  gap: 10px;\n  width: fit-content;\n  height: 56px;\n  color: #17477E;\n  background: transparent;\n  border: solid 2px #17477E;\n  border-radius: 8px;\n}\n\n.blue-button {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  padding: 16px 32px;\n  gap: 10px;\n  width: 206px;\n  height: 56px;\n  background: #17477E;\n  border-radius: 8px;\n}\n\n.register-margin {\n  padding: 2rem 8rem;\n}\n\n.register-margin-2 {\n  padding: 2rem 4rem;\n}\n.screen-icons {\n  width: 95%;\n}\n\n.mobile-icons {\n  width: 75%;\n}\n\n.mobile-license {\n  margin-right: -1rem;\n  float: right;\n}\n\n.mobile-plan-card {\n  width: 10vh;\n}\n\n.mobile-card-pad {\n  padding-bottom: 2rem;\n}\n\n.mobile-card {\n  margin: auto;\n  width: 90%;\n  height: fit-content;\n  left: 0px;\n  top: 0px;\n  background: #d1dae545;\n  border-radius: 16px;\n}\n\n.mobile-nav {\n  position: fixed;\n  top: 0;\n  width: 100%;\n  z-index: 99;\n}\n\n.mobile-center-alt {\n  margin-top: 2rem;\n  text-align: center;\n  font-size: 32px;\n}\n\n.mobile-pa-alt {\n  text-align: center;\n  font-size: 14px;\n  margin-bottom: 2rem;\n}\n\n.web-pension-vid{\n  width: 800px;\n  height: 650px;\n  margin: auto;\n  background: #D2D2D2;\n  border-radius: 15px;\n}\n\n.web-vid {\n  width: 850px;\n  height: 450px;\n  left: 0px;    \n  border-radius: 15px;\n  background: #D2D2D2;\n}\n\n.mobile-vid {\n  margin: auto;\n  width: 343px;\n  height: 255px;\n  left: 16px;\n  top: 2182px;\n\n  background: #D9D9D9;\n  border-radius: 16px;\n}\n\n.mobile-center {\n  margin-top: 5rem !important;\n  text-align: center;\n  font-size: 32px;\n}\n\n.mobile-about-us-img {\n  margin: auto;\n  width: 95%;\n  height: 35vh;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\n.register-center{\n  width: fit-content;\n  text-align: center;\n}\n\n.index-scrolling{\n  color: #036C4F !important;\n}\n\n.dial-bg{\n  background: #F1F4F7;\n  /* width: fit-content; */\n}\n\n.index-heading{\n  left: 0%;\n  right: 10.03%;\n  top: 0%;\n  bottom: 6.8%;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 32px;\n  line-height: 48px;\n  color: #133B69;\n}\n\n.index-heading-alt{\n  left: 0%;\n  right: 10.03%;\n  top: 0%;\n  bottom: 6.8%;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 28px;\n  line-height: 48px;\n  color: #133B69;\n}\n\n\n.absolute-p {\n  position: absolute;\n}\n\n.mobile-page-images {\n  margin: 2rem 0rem -1rem;\n  width: 100%;\n  height: 46vh;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\n.mobile-page-images-2 {\n  margin-top: 2rem;\n  margin-left: 0rem;\n  width: 43vh;\n  height: 35vh;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\n.page-images {\n  margin-top: 4rem;\n  width: 450vh;\n  height: 62vh;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\n.calculator-img{\n  background-image: url(\"../assets/cal-card.png\");\n  background-size: 100% 100% !important;\n  height: 405px;\n  width: 500px;\n  margin: 5rem 0rem;\n}\n\n.cal-sub-heading{\n  height: 24px;\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n  color: #434343;\n}\n\n.cal-sub-heading-mobile{\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n  color: #434343;\n}\n\n.neg-margin{\n  margin-top: -3rem;\n}\n\n.neg-margin-mobile{\n  margin-top: -1.5rem;\n}\n\n.pen-list-item{\n  display: list-item;\n}\n\n.neg-button-margin{\n  margin-top: -1rem;\n}\n\n.cal-padding{\n  padding: 1rem 2rem;\n}\n\n.freq-margin{\n  justify-content: center;\n  width: fit-content !important;\n  display: flex;\n  margin-top: 1.2rem !important;\n  margin-left: 0rem !important;\n}\n\n.expect-label-margin{\n  margin-left: 2.5rem !important;\n}\n\n.investment-calculator-margin{\n  background-image: url(\"../assets/cal-card.png\");\n  background-size: 100% 100% !important;\n  height: 415px;\n  width: 500px;\n  margin: 1rem 3rem;\n}\n\n.investment-calculator-margin-mobile{\n  background-image: url(\"../assets/cal-card.png\");\n  background-size: 100% 100% !important;\n  width: 370px;\n  height: 445px;\n  margin: 1rem 0.5rem;\n}\n\n.swirl-size{\n  width: 6rem;\n  height: 6rem;\n}\n\n.pen-img{\n  width: 5rem;\n  height: 5rem;\n}\n\n.low-interest-margin{\n  margin-top: 33px !important;\n}\n\n.low-interest-text-margin{\n  margin-top: 28px !important;\n}\n\n.team-name-margin-alt-1{\n  margin: 2rem 0rem !important;\n}\n\n.team-name-margin-alt-2{\n  margin: 4rem 0rem !important;\n}\n\n.margin-alt{\n  margin: 0.5rem;\n}\n\n.about-gr-text{\n  font-weight: 600 !important;\n  color: #036C4F !important;\n}\n\n.about-pg-trust{\n  color: #F6C911;\n}\n\n.about-pg-stability{\n  color: #9EBBDC;\n}\n\n.about-pg-assurance{\n  color: #036C4F;\n}\n\n.about-pg-progress{\n  color: #133B69;\n}\n\n.about-pg-default{\n  height: 4rem;\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 64px;\n  line-height: 96px;\n}\n\n.about-pg-default-alt{\n  height: 3rem;\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 40px;\n  text-align: center;\n  line-height: 96px;\n}\n\n.team-name-mobile{\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 30px;\n  color: #434343;\n}\n\n.team-role-mobile{\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n  color: #696969;\n}\n\n.about-define{\n  width: 618px;\n  height: 108px;\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 24px;\n  line-height: 36px;\n  color: #696969;\n  text-align: left;\n}\n\n.about-bl-text{\n  font-weight: 600 !important;\n  color: #133B69 !important;\n}\n\n.about-heading-sub-width{\n  width: 276px;\n}\n\n\n\n.about-default-text-alt{\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 30px;\n  text-align: center;\n  color: #696969;\n}\n\n.about-default-text{\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 30px;\n  text-align: center;\n  color: #696969;\n}\n\n.about-pg-bg-2-alt{\n  padding: 0px 10px !important;\n}\n\n.about-heading-sub-mobile{\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n  text-align: center;\n  color: #696969;\n}\n\n.about-heading-mobile{\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 36px;\n  text-align: center;\n  color: #133B69;\n}\n\n.about-pg-bg-2{\n  align-items: center;\n  padding: 0px 24px;\n  gap: 8px;\n  height: 76px;\n  left: 1011px;\n  top: 95px;\n  background: #133B69;\n  color: white !important;\n  border-radius: 61px;\n}\n\n.about-pg-bg-1{\n  justify-content: center;\n  align-items: center;\n  padding: 0px 24px;\n  gap: 8px;\n  width: 228px;\n  height: 76px;\n  background: #036C4F;\n  border-radius: 61px;\n  color: white !important;\n}\n\n.pen-margin-alt{\n  margin: 0rem 2rem;\n}\n\n.pen-margin-alt-mobile{\n  margin: 0rem 1.5rem;\n}\n\n.tooltip-text{\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n  color: #434343;\n  width: 273px;\n}\n\n.tooltip-text-alt{\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n  color: #fff;\n}\n\n.alt-mt-2{\n  margin-top: 0.3rem !important;\n}\n\n.tooltip-contribute-element{\n  background: rgb(19 59 106 / 73%) !important;\n  left: 0rem;\n  top: 2rem;\n  border-radius: 5px;\n}\n\n.tooltip-left-element{\n  width: 305px;\n  height: 112px;\n  background: rgba(46, 151, 122, 0.05) !important;\n  left: -18rem;\n  top: 2rem;\n  border-radius: 32px;\n  padding: 1rem 1.5rem\n}\n\n.tooltip-right-element{\n  width: 305px;\n  height: 112px;\n  background: rgba(46, 151, 122, 0.05) !important;\n  left: 5rem;\n  top: 2rem;\n  border-radius: 32px;\n  padding: 1rem 1.5rem\n}\n\n.pen-sub{\n  width: 305px;\n  /* height: 48px; */\n  left: 583px;\n  top: 2008px;\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n  color: #696969;\n}\n\n.pen-heading{\n  font-style: normal;\n  font-weight: 600;\n  font-size: 23px;\n  line-height: 36px;\n  color: #133B69;\n  margin-right: auto;\n  /* margin-top: 1rem; */\n}\n\n.pen-heading-margin-alt-1{\n  margin-top: 22px !important;\n}\n\n.pen-heading-margin-alt-2{\n  margin-top: 7px !important;\n}\n\n.pen-heading-alt-2 {\n  font-style: normal;\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 25px;\n  color: #133B69;\n  margin-right: auto;\n}\n\n.pen-heading-alt{\n  font-style: normal;\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 36px;\n  color: #133B69;\n  margin-right: auto;\n}\n\n.disclaimer-text{\n  width: 560px;\n  height: 64px;\n  left: 446px;\n  top: 1584px;\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 20px;\n  color: #696969;\n}\n\n.disclaimer-text-alt{\n  height: 64px;\n  left: 446px;\n  top: 1584px;\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 20px;\n  color: #696969;\n}\n\n.disclaimer-img{\n  width: 1rem;\n  height: 1rem;\n  margin: 0.7rem;\n}\n\n.disclaimer-bubble{\n  width: 636px;\n  height: 84px;\n  left: 402px;\n  top: 1572px;\n  background: rgba(253, 244, 207, 0.31);\n  border-radius: 16px;\n}\n\n.pension-cal-card{\n  width: 374px;\n  height: 208px;\n  background: #f0f8ffd1;\n  border-radius: 32px;\n}\n\n.pension-cal-card-alt{\n  height: 190px;\n  background: #f0f8ffd1;\n  border-radius: 32px;\n}\n\n.ul-postion-alt{\n  width: 6rem;\n  left: 0rem;\n}\n\n.ul-postion-alt-2{\n  left: 0rem;\n}\n\n.ul-postion{\n  width: 15rem;\n  left: -3rem;\n}\n\n.voda_img_position{\n  width: 10rem;\n  margin-left: 5rem;\n}\n\n.expected-amount-position{\n  text-align: left !important;\n  width: 10rem !important;\n  margin-left: -0.5rem;\n}\n\n.expected-amount-position-mobile{\n  text-align: left !important;\n  width: 80px !important;\n}\n\n.partner-img{\n  width: 38.18px;\n  height: 40px;\n}\n\n.select-position{\n  position: absolute;\n  top: 74.5rem;\n  left: 29.5rem;\n}\n\n.partner-name{\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 20px;\n  color: #8E8E8E;\n}\n\n.partner-description{\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 24px;\n  color: #696969;\n}\n\n.listbox-drop-span{\n  width: 18rem;\n  display: inline-flex;\n}\n\n.cal-element-alt-1{\n  text-align: center;\n  height: 48px !important;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 32px;\n  line-height: 48px;\n  background: transparent;\n  width: 2rem;\n}\n\n.box-frame-alt-3{\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 8px;\n  gap: 25px;\n  height: 52px;\n  width: 100% !important;\n  border: 0.6px solid #696969;\n  border-top-right-radius: 8px;\n  border-bottom-right-radius: 8px\n}\n\n.box-frame-alt-2{\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 8px;\n  gap: 25px;\n  height: 48px;\n  border: 0.6px solid #696969;\n  border-top-left-radius: 8px;\n  border-bottom-left-radius: 8px\n}\n\n.box-frame-alt-4{\n  width: 105px !important;\n}\n\n.box-frame-alt-5{\n  width: 95% !important;\n}\n\n.box-frame-alt-6{\n  width: 90% !important;\n}\n\n.box-frame-alt{\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 8px;\n  gap: 25px;\n  width: auto;\n  height: 52px;\n  border: 0.6px solid #696969;\n  border-radius: 8px;\n}\n\n.box-frame-text{\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  /* padding: 4px 8px; */\n  gap: 8px;\n  width: 55px;\n  height: 32px;\n  background: rgba(19, 59, 105, 0.18);\n  border-radius: 8px;\n}\n\n.box-frame{\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 8px;\n  gap: 25px;\n  width: 65px !important;\n  height: 52px;\n  border: 0.6px solid #696969;\n  border-radius: 8px;\n  /* transform: matrix(-1, 0, 0, 1, 0, 0); */\n}\n\n.cal-element-alt-1::placeholder {\n  height: 48px;\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 32px;\n  line-height: 48px;\n  color: #1E1E1E;\n}\n\n.cal-element{\n  text-align: center;\n  height: 48px !important;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 32px;\n  line-height: 48px;\n  background: transparent;\n  width: 2rem;\n}\n\n.cal-element-mobile{\n  text-align: center;\n  height: 48px !important;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 20px;\n  line-height: 48px;\n  background: transparent;\n  width: 3rem;\n}\n\n.cal-element-mobile::placeholder {\n  height: 48px;\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 20px;\n  line-height: 48px;\n  color: #1E1E1E;\n}\n\n.result-bg{\n  background: rgba(19, 59, 105, 0.03);\n}\n\n.sub-heading-mobile{\n  font-size: 12px !important;\n}\n\n.expected-result-p-alt{\n  font-size: 14px !important;\n}\n\n.span-neg-margin{\n  margin-right: 1rem;\n}\n\n.span-neg-margin-left{\n  margin-left: -3rem;\n}\n\n.expected-result-para{\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 24px;\n  line-height: 36px;\n  color: #434343;\n}\n\n.expected-result-p{\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 19px;\n  line-height: 36px;\n  color: #434343;\n  display: inline-flex;\n}\n\n.expected-result-bg{\n  background: #D1DAE5;\n}\n\n.cal-element-alt{\n  width: 4rem !important;\n}\n\n.cal-element-alt-2{\n  width: 8rem !important;\n}\n\n.item-button{\n  background: #133b69;\n  color: white;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 16px 24px;\n  gap: 10px;\n  font-size: 1.5rem;\n  font-weight: 600;\n  height: 52px;\n  border: 1px solid #17477E;\n  border-radius: 30px;\n}\n\n.item-button-alt-2 {\n  color: #c9c9c9 !important;\n  background: #dad7cc !important;\n  border: 1px solid #d9d7cc !important;\n}\n\n.item-button-alt{\n  color: #133b69 !important;\n  background: #F6C911 !important;\n  border: 1px solid #F6C911 !important;\n}\n\n.calculator-button{\n  background: #133b69;\n  color: white;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 16px 24px;\n  gap: 10px;\n  width: 259px;\n  height: 52px;\n  border: 1px solid #17477E;\n  border-radius: 8px;\n}\n\n:where(.vi__container){\n  width: 100% !important;\n  height: 75px !important;\n  line-height: 75px !important;\n}\n\n.verification-container{\n  gap: 2rem;\n  width: 100%;\n}\n\n:where(.vi__character--selected){\n  outline: 2px solid #133b69 !important;\n  color: #133b69 !important;\n}\n\n.vi__character{\n  font-size: 42px !important;\n  border-radius: 10px;\n  background-color: #f5f5f5;\n  border: none;\n  width: 100%;\n}\n\n.custom-verification-character:focus {\n  border-color: black; /* Change border color on focus */\n}\n\n.verify-card-box-button{\n  background: #133b69;\n  color: white;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 16px 24px;\n  gap: 10px;\n  width: '100%';\n  height: 52px;\n  border: 1px solid #17477E;\n  border-radius: 8px;\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.auto-margin{\n  margin: 0 auto;\n}\n\n.cal-element-alt-3{\n  width: 11rem !important;\n}\n\n.cal-amount-alt-1{\n  margin-top: 0.5rem !important;\n  margin-left: unset !important\n}\n\n.cal-amount-alt{\n  margin-top: 12px;\n  margin-left: 0.3rem;\n}\n\n.result-yrs{\n  font-size: 14px !important;\n  margin-left: 5px;\n}\n\n.result-show-graph-text{\n  height: 20px;\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 20px;\n  color: #17477E;\n}\n\n.result-show-graph{\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 16px 24px;\n  gap: 10px;\n  width: 140px;\n  height: 52px;\n  border: 1px solid #17477E;\n  border-radius: 8px;\n}\n\n.result-back-button{\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 16px 24px;\n  gap: 10px;\n  width: 259px;\n  height: 52px;\n  border: 1px solid #17477E;\n  border-radius: 8px;\n}\n\n.result-alt{\n  font-size: 16px;\n  margin-right: 5px;\n  margin-top: 13px;\n}\n\n.cal-element::placeholder {\n  height: 48px;\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 32px;\n  line-height: 48px;\n  color: #1E1E1E;\n}\n\n.cal-heading{\n  height: 48px;\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 32px;\n  line-height: 48px;\n  text-align: center;\n  color: #133B69;\n  margin-top: 1rem;\n}\n\n.cal-heading-mobile{\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 36px;\n  text-align: center;\n  padding: 0.5rem;\n  color: #133B69;\n}\n\n.first-image {\n  background-image: url('../assets/first.png');\n  width: 100%;\n  object-fit: cover;\n}\n\n.spinner-position-alt{\n  margin: auto !important;\n}\n\n.spinner-position{\n  margin: 10rem auto;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n}\n\n.vl {\n  border-left: 1px solid black;\n  height: 70px;\n}\n\n.flag-padding{\n  padding: 2rem 1rem;\n}\n\n.bog-padding{\n  padding: 2rem 1rem;\n}\n\nhr.default {\n  border-top: 1px solid black;\n  width: 55rem;\n  margin-top: 3rem;\n  margin-bottom: 3rem;\n}\n\nhr.default-mobile {\n  border-top: 1px solid black;\n  width: 20rem;\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n}\n\n.img-width{\n  width: 2rem;\n}\n\n.mobile-first-image-alt{\n  position: absolute;\n  width: 513px;\n  height: 388.23px;\n\n  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.2) 82.81%), url('../assets/mobile/mobile_landing.png');\n}\n\n.mobile-first-image {\n  background-image: url('../assets/mobile/mobile_landing.png');\n  background-size: 100% 100% !important;\n}\n\n.second-image {\n  background-image: url('../assets/second.png');\n}\n\n.mobile-second-image{\n  background-image: url('../assets/mobile/mobile_pension.png');\n}\n\n.third-image {\n  background-image: url('../assets/third.png');\n}\n\n.mobile-third-image{\n  background-image: url('../assets/mobile/mobile_welfare.png');\n}\n\n.about-image {\n  background-image: url('../assets/about_us.png');\n}\n\n.fourth-image {\n  background-image: url('../assets/fourth.png');\n}\n\n.mobile-fourth-image{\n  background-image: url('../assets/mobile/mobile_loan.png');\n}\n\n.pension-card-plan {\n  width: 273px;\n  height: 272px;\n  left: 100px;\n  top: 1256px;\n  background: #FFFFFF;\n  border-radius: 8px;\n}\n\n.pension-card-plan-alt:hover {\n  box-shadow: 0px 19px 39px rgba(38, 38, 38, 0.07);\n}\n\n.welfare-card-plan {\n  box-sizing: border-box;\n  width: 318px;\n  height: 328px;\n  left: 100px;\n  top: 1168px;\n  background: #FFFFFF;\n  border: 1px solid #FFFFFF;\n  border-radius: 8px;\n}\n\n.welfare-card-plan-alt:hover {\n  box-shadow: 0px 19px 39px rgba(38, 38, 38, 0.07);\n}\n\n.mt-override {\n  margin-top: 5rem !important\n}\n\n.app-w{\n  width: 6rem;\n  margin: auto;\n}\n\n.hr-vertical-sm{\n  background-color: #000;\n  color: #9da4abd1;\n  -webkit-transform: rotate(90deg);\n  width: 1.2rem;\n  height: 1px;\n  border: 0px;\n  margin-top: 0.6rem;\n  overflow: hidden;\n}\n\n.hr-vertical {\n  background-color: #9da4abd1;\n  color: #9da4abd1;\n  -webkit-transform: rotate(90deg);\n  width: 4rem;\n  height: 2px;\n  border: 2px;\n  margin-left: 7px;\n  overflow: hidden;\n}\n\n.journey-card{\n  margin: auto;\n  width: 90%;\n  height: fit-content;\n  left: 0px;\n  top: 0px;\n  background: #FFFFFF;\n  box-shadow: 0px 19px 39px rgba(38, 38, 38, 0.07);\n  border-radius: 8px;\n}\n\n.mobile-sign-heading{\n  width: 265px;\n  height: 72px;\n  left: 32px;\n  top: 3308px;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 36px;\n  color: #FFFFFF;\n}\n\n.mobile-sign-button {\n  width: 119px;\n  height: 52px;\n  background: #FFFFFF;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.sign-button {\n  width: 10rem;\n  height: 3rem;\n  background: #1e4f86fc;\n  /* margin: 0 auto; */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.address-padding{\n  padding: 0rem 1.5rem;\n}\n\n.sign-up-mb {\n  margin-bottom: 2rem !important;\n}\n\n.goal-heading{\n  width: auto;\n  height: 96px;\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 30px;\n  line-height: 48px;\n  color: #133B69;\n  order: 0;\n  flex-grow: 0;\n}\n\n.goal-sub-height{\n  height: 50px !important;\n}\n\n.goal-text{\n  width: 340px;\n  height: 90px;\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 30px;\n  color: #696969;\n  flex: none;\n  order: 1;\n  flex-grow: 0;\n}\n\n.goal-img{\n  width: 10rem;\n}\n\n.bg-default-light-gray{\n  background-color: #e8e8e880;\n}\n\n::placeholder {\n  /* padding: 1rem; */\n  opacity: 1; /* Firefox */\n}\n\n.mobile-register-top{\n  margin-top: 5rem;\n  width: 90%;\n}\n\n.register-top {\n  margin-top: 8rem;\n  height: 203px;\n}\n\n.footer-hidden {\n  visibility: hidden;\n}\n\n.sign-text {\n  color: white;\n  font-weight: 400;\n  background-color: #355f90;\n  padding: 5px;\n}\n\n.sign-text:focus{\n    outline: 0.1em solid white;\n}\n\n.mobile-image-card {\n  font-size: 10px !important; \n}\n\n.image-card {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 12px;\n  gap: 10px;\n  width: max-content;\n  position: absolute;\n  font-size: 12px;\n  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);\n  border-radius: 16px;\n}\n\n.welfare-color{\n  color: #036C4F;\n}\n\n.img-welfare-card {\n  background: #F4FFFC;\n  color: #036C4F;\n}\n\n.img-loan-card {\n  background: #FFFAF8;\n  color: #804527 !important;\n}\n\n.img-pension-card {\n  background: #F7FAFF;\n}\n\n.sign-text::placeholder {\n  color: white !important;\n}\n\n.sign-text::-ms-input-placeholder { /* Internet Explorer 10-11 */\n  color: white !important;\n}\n\n.sign-text::-ms-input-placeholder { /* Microsoft Edge */\n  color: white !important;\n}\n\n.plan-width{\n  width: 26rem !important;\n}\n\n.swirl-padding {\n  padding: 0rem 20rem !important;\n}\n\n.plan-width-p{\n  width: 26rem !important;\n}\n\n.mobile-accordion-color{\n  font-style: normal;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 25px;\n  color: #696969;\n}\n\n.accordion-color{\n  font-style: normal;\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 36px;\n  color: #696969;\n}\n\n.accordion-color:focus{\n  color: #133B69 !important;\n}\n\n.mobile-accordion-color:focus{\n  color: #133B69 !important;\n}\n\n.privacy-sub-p-alt{\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 13px;\n  margin-top: 1rem;\n  line-height: 30px;\n  color: #133B69;\n}\n\n.privacy-header{\n  height: 60px;\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 40px;\n  text-align: center;\n  line-height: 60px;\n  color: #133B69;\n}\n\n.extra-margin-top{\n  margin-top: 2rem !important;\n}\n\n.extra-margin-top-alt{\n  margin-top: 4rem !important;\n}\n\n.mobile-privacy-header-alt{\n  font-size: 32px !important;\n  text-align: center !important;\n}\n\n.mobile-privacy-header{\n  height: 60px;\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 40px;\n  text-align: left;\n  line-height: 60px;\n  color: #133B69;\n}\n\n.privacy-sub-header{\n  height: 30px;\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 30px;\n  color: #133B69;\n}\n\n.privacy-padding{\n  padding: 0rem 1.3rem;\n}\n\n.privacy-header-width{\n  width: 280px !important;\n  height: 60px !important;\n}\n\n.privacy-sub-width{\n  width: 280px !important;\n  height: 90px !important;\n}\n\n.privacy-sub-width-alt{\n  width: 280px !important;\n  height: 60px !important;\n}\n\n.privacy-para-padding{\n  padding: 0rem 5rem;\n}\n\n.mobile-privacy-para-padding{\n  padding: 0rem 2rem;\n}\n\ndiv.scroll{\n  height: 200vh;\n  overflow-x: hidden;\n  overflow-y: auto;\n  text-align:justify;\n}\n\n.privacy-sub-paragraph{\n  height: 30px;\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 30px;\n  color: #434343;\n}\n\n.privacy-para-sub-header{\n  font-size: 18px !important;\n}\n\n.privacy-sub-p{\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 13px;\n  margin-top: 1rem;\n  line-height: 30px;\n  color: #434343;\n\n}\n\n.privacy-sub-alt{\n  width: auto !important;\n}\n\n.privacy-sub-mobile{\n  width: 340px;\n  height: 72px;\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n  text-align: center;\n  color: #434343;\n}\n\n.privacy-sub{\n  width: 402px;\n  height: 30px;\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 20px;\n  line-height: 30px;\n  text-align: center;\n  color: #696969;\n}\n\n.mobile-privacy-sub-alt{\n  font-size: 14px !important;\n  text-align: center !important;\n}\n\n.mobile-privacy-sub{\n  height: 30px;\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 20px;\n  line-height: 30px;\n  text-align: left;\n  color: #696969;\n}\n\n.img-icon-width {\n  width: 37vh !important;\n  max-width: 6vh;\n}\n\n.pension-card {\n  margin-left: -12vh;\n  margin-top: 18vh;\n}\n\n.mobile-pension-card {\n  margin-left: -3vh;\n}\n\n.welfare-heading{\n  width: 297px;\n  height: 72px;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 36px;\n  color: #133B69;\n}\n\n.welfare-card {\n  margin-bottom: 3vh;\n}\n\n.mobile-welfare-card{\n  margin-left: -12vh;\n  margin-top: -3vh;\n}\n\n.mobile-loan-card {\n  margin-left: -13vh;\n  margin-top: -3vh;\n}\n\n.loan-card {\n  margin-right: -10vh;\n}\n\n.box::before {\n  top: 0;\n  left: 0;\n  z-index: 1;\n  width: 100%;\n  content: '';\n  height: 10px;\n  position: absolute;\n  /* background: linear-gradient(180deg, #ff8e71, rgba(255, 142, 113, 0)); */\n}\n.box::after {\n  left: 0;\n  bottom: 0;\n  z-index: 1;\n  width: 100%;\n  content: '';\n  height: 10px;\n  position: absolute;\n  /* background: linear-gradient(180deg, rgba(255, 142, 113, 0), #ff8e71); */\n}\n\np {\n  float: left;\n}\n\n.item-1 {\n  padding: 0px 25px !important;\n}\n\n.item-3 {\n  padding: 10px 18px !important;\n}\n\n.coming-soon{\n  width: 132px;\n  height: 30px;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 20px;\n  line-height: 30px;\n  color: #696969;\n}\n\n.scroll-effect{\n  -webkit-animation: scrollUp 5s ease-in-out infinite normal;\n  animation: scrollUp 5s ease-in-out infinite normal;\n}\n\nul {\n  float: right;\n  margin: 0;\n  padding: 0;\n}\nul li {\n  opacity: 1;\n  height: 50px;\n  /* padding: 0px 15px; */\n  list-style: none;\n}\n\n.box-margin{\n  margin-left: 0.3rem;\n  margin-top: 1rem;\n}\n\n@-webkit-keyframes scrollUp {\n  from {\n    -webkit-transform: translateY(0);\n            transform: translateY(0);\n  }\n  to {\n    -webkit-transform: translateY(-80%);\n            transform: translateY(-80%);\n  }\n}\n\n@keyframes scrollUp {\n  from {\n    -webkit-transform: translateY(0);\n            transform: translateY(0);\n  }\n  to {\n    -webkit-transform: translateY(-80%);\n            transform: translateY(-80%);\n  }\n}\n\n#container {\n  color:#999;\n  text-transform: uppercase;\n  font-size:36px;\n  font-weight:bold;\n  padding-top:200px;  \n  position:fixed;\n  width:100%;\n  bottom:45%;\n  display:block;\n}\n\n.div-margin {\n  margin-top: 3px;\n}\n\n.fade-in-text {\n  font-size: 60px;\n  animation: fadeIn 15s;\n  -webkit-animation: fadeIn 15s;\n  -moz-animation: fadeIn 15s;\n  -o-animation: fadeIn 15s;\n  -ms-animation: fadeIn 15s;\n  opacity: 1;\n}\n\n@keyframes fadeIn {\n  0% { opacity: 0; }\n  100% { opacity: 1; }\n}\n\n@-moz-keyframes fadeIn {\n  0% { opacity: 0; }\n  100% { opacity: 1; }\n}\n\n@-webkit-keyframes fadeIn {\n  0% { opacity: 0; }\n  100% { opacity: 1; }\n}\n\n@-o-keyframes fadeIn {\n  0% { opacity: 0; }\n  100% { opacity: 1; }\n}\n\n@-ms-keyframes fadeIn {\n  0% { opacity: 0; }\n  100% { opacity: 1; }\n}\n\n.animated {\n  background-repeat: no-repeat;\n  background-position: left top;\n  -webkit-animation-duration: 3s;\n  animation-duration: 3s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n  animation-name: fadeInDown;\n}\n\n/* @-webkit-keyframes fadeInLeft {\n0% {\n   opacity: 0;\n   -webkit-transform: translateX(20px);\n}\n100% {\n   opacity: 1;\n   -webkit-transform: translateX(0);\n}\n} */\n/* \n@keyframes fadeInLeft {\n0% {\n   opacity: 0;\n   transform: translateX(20px);\n}\n100% {\n   opacity: 1;\n   transform: translateX(0);\n}\n} */\n\n/* .fadeInLeft {\n  -webkit-animation-name: fadeInLeft;\n  animation-name: fadeInLeft;\n} \n */\n\n\n/* .reveal {\n  position: relative;\n  opacity: 0;\n}\n\n.reveal.active {\n  opacity: 1;\n} */\n\n/* .active.fade-bottom {\n  animation: fade-bottom 1s ease-in;\n}\n\n.active.fade-left {\n  animation: fade-left 0s ease-in;\n}\n\n.active.fade-right {\n  animation: fade-right 0s ease-in;\n}\n\n@keyframes fade-bottom {\n  0% {\n    transform: translateY(50px);\n    opacity: 1;\n  }\n  100% {\n    transform: translateY(0);\n    opacity: 1;\n  }\n} */\n/* @keyframes fade-left {\n  0% {\n    transform: translateX(-100px);\n    opacity: 1;\n  }\n  100% {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n@keyframes fade-right {\n  0% {\n    transform: translateX(100px);\n    opacity: 0;\n  }\n  100% {\n    transform: translateX(0);\n    opacity: 1;\n  }\n} */\n\n.goal-heading-max{\n  width: max-content !important;\n}\n\n@media screen and (max-width: 768px) {\n  .investment-calculator-margin{\n    background-image: url(\"../assets/cal-card.png\");\n    background-size: 100% 100% !important;\n    height: 415px;\n    margin: auto;\n  }\n\n  .nav-agent-button-text {\n    color: #17477E;\n    font-weight: 600;\n    font-size: 15px;\n  }\n\n  .nav-agent-button {\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    padding: 10px 10px;\n    gap: 10px;\n    width: -moz-fit-content;\n    width: fit-content;\n    height: 45px;\n    color: #17477E;\n    background: transparent;\n    border: solid 2px #17477E;\n    border-radius: 8px;\n}\n\n  .eligible-img {\n    width: 70px;\n    height: 80px;\n  }\n\n  .element-header-altered {\n    color: #404040 !important;\n    font-size: 25px !important;\n    height: auto !important;\n    line-height: normal !important;\n  }\n\n  .element-header {\n    height: 45px;\n    font-family: 'Poppins';\n    font-style: normal;\n    font-weight: 600;\n    font-size: 30px;\n    line-height: 30px;\n    text-align: center;\n    color: #133B69;\n}\n  \n  .about-header{\n    font-family: 'Poppins';\n    font-style: normal;\n    font-weight: 600;\n    font-size: 30px;\n    line-height: 30px;\n    text-align: center;\n    color: #133B69;\n  }\n\n  .react-pdf__Page__canvas {\n    margin: 0 auto;\n    display: block;\n    user-select: none;\n    width: 100% !important;\n    height: 841px;\n  }\n  \n  .page-images {\n    margin-top: 4rem;\n    width: inherit;\n    height: 62vh;\n    background-repeat: no-repeat;\n    background-size: cover;\n  }\n\n  .accordion-width {\n    width: auto;\n  }\n\n  .apply-now-button{\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    padding: 16px 32px;\n    gap: 10px;\n    width: 144px;\n    height: 56px;\n    background: #133B69;\n    border-radius: 8px;\n    flex: none;\n    order: 2;\n    margin-top: 2rem;\n    margin-left: 3rem;\n    flex-grow: 0;\n  }\n\n  .request-text {\n    width: 320px;\n    height: 100px;\n    left: 70px;\n    bottom: 53px;\n    font-style: normal;\n    font-weight: 600;\n    font-size: 30px;\n    line-height: 48px;\n    color: #FFFFFF;\n  }\n\n  .top-button {\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    padding: 16px 32px;\n    gap: 4px;\n    width: 222px;\n    height: 62px;\n    background: #133B69;\n    border-radius: 8px;\n    flex: none;\n    flex-grow: 0;\n  }\n}\n\n@media screen and (min-device-width: 1024px) and (max-device-width: 2024px) {\n  .goal-heading{\n    width: 300px;\n    height: 96px;\n    font-style: normal;\n    font-weight: 600;\n    font-size: 25px;\n    line-height: 48px;\n    color: #133B69;\n    order: 0;\n    flex-grow: 0;\n  }\n}\n\n@media screen and (max-device-width: 480px)\n  and (orientation: portrait) {\n    .when-to-show{\n      display: none;\n    }\n  }\n\n@media screen and (max-device-width: 640px)\nand (orientation: landscape) {\n  .when-to-show{\n    display: none;\n  }\n}\n\n@media screen and (max-device-width: 640px) {\n  .when-to-show{\n    display: none;\n  }\n}\n\n@media (device-height: 568px) and (device-width: 320px)\n  and (-webkit-min-device-pixel-ratio: 2) {\n    .when-to-show{\n      display: none;\n    }\n  }\n\n@media (min-device-height: 667px) and (min-device-width: 375px)\nand (-webkit-min-device-pixel-ratio: 3) {\n  .when-to-show{\n    display: none;\n  }\n}\n\n\n@media screen and (min-device-width: 768px)\n  and (max-device-width: 1024px) {\n    .when-to-show{\n      display: block;\n    }\n\n    .react-pdf__Page__canvas {\n      margin: 0 auto;\n      display: block;\n      user-select: none;\n      width: 100% !important;\n      height: 841px;\n    }\n\n    .register-mid-img{\n      width: 40vh !important;\n    }\n\n    .page-images {\n      margin-top: 4rem;\n      width: inherit;\n      height: 62vh;\n      background-repeat: no-repeat;\n      background-size: cover;\n    }\n\n    .request-text {\n      width: 340px;\n      height: 96px;\n      left: 71px;\n      bottom: 53px;\n      font-style: normal;\n      font-weight: 600;\n      font-size: 32px;\n      line-height: 48px;\n      color: #FFFFFF;\n    }\n\n    .pension-card {\n      margin-left: 0vh;\n      margin-top: 25vh;\n    }\n\n    .loan-card {\n      margin-right: -1vh;\n    }\n\n    .nav-items-margin{\n      margin-left: -6rem;\n    }\n\n    .accordion-width {\n      width: auto;\n    }\n  }\n\n  .landing-header{\n    font-family: 'Poppins';\n    font-style: normal;\n    font-weight: 600;\n    font-size: 56px;\n    line-height: 84px;\n    color: #133B69;\n  }\n\n  .note::after {\n    content: '';\n    width: 20%;\n    height: 2px;\n    border-radius: 999px;\n    background-color: #036C4F;\n    /* background: linear-gradient(135deg, rgba(43,171,217,1) 0%, rgba(0,130,200,1) 100%); */\n    position: absolute;\n    top: -1.8em;\n    left: 0;\n  }\n  .note {\n    font-size: 0.8em;\n    color: #036C4F;\n    position: relative;\n    margin-top: 4em;\n  }\n  \n  /* Scroller styling */\n  .mobile-scroller{\n    height: 1.6rem;\n    line-height: 1.7em;\n    position: relative;\n    overflow: hidden;\n    width: 6.3em;\n    margin-left: 0.5rem;\n    display: inline-block;\n  }\n\n  .mobile-scroller > span {\n    color: #036C4F;\n    position: absolute;\n    font-style: normal;\n    font-weight: 600;\n    font-size: 28px;\n    top: 0;\n    animation: slide 5s infinite;\n    display: inline-block;\n  }\n\n  .scroller {\n    height: 3rem;\n    line-height: 1.23em;\n    position: relative;\n    overflow: hidden;\n    width: 5em;\n    margin-left: 1rem;\n    display: inline-block;\n  }\n\n  .scroller > span {\n    color: #036C4F;\n    position: absolute;\n    font-style: normal;\n    font-weight: 600;\n    font-size: 56px;\n    top: 0;\n    animation: slide 5s infinite;\n    display: inline-block;\n  }\n\n  @keyframes slide {\n    0% {\n      top: 0;\n    }\n    25% {\n      top: -1em;\n    }\n    50% {\n      top: -2.1em;\n    }\n    /* 75% {\n      top: -3.6em;\n    } */\n  }\n\n/* .goal-move{\n  -webkit-animation:fadeIn 5.6s linear;\n  animation:fadeIn 5.6s linear;\n  -webkit-animation-fill-mode:both;\n  animation-fill-mode:both;\n} */\n\n.goal-move div:nth-child(1){\n  -webkit-animation-delay:4.26s;\n  animation-delay:4.26s;\n}\n\n.goal-move div:nth-child(2){\n  -webkit-animation-delay:6.6s;\n  animation-delay:6.6s;\n}\n\n.goal-move div:nth-child(3){\n  -webkit-animation-delay:10.76s;\n  animation-delay:10.76s;\n}\n\n.goal-move div:nth-child(4){\n  -webkit-animation-delay:12s;\n  animation-delay:12s;\n}\n\n@-webkit-keyframes fadeIn  {\n  0% {\n    opacity:0;\n  }\n  \n  75% {\n    opacity:0.6;\n  }\n  \n  100% {\n    opacity:2;\n  }\n\n}\n\n.dropdown {\n  display: inline-block;\n  width: 200px;\n  margin-left: 0.3rem;\n}\n\n.dropdown-header {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n}\n\n.dropdown-body {\n  background-color: #fff;\n  position: absolute;\n  padding: 5px;\n  border-top: 1px solid #E5E8EC;\n  display: none;\n}\n\n.dropdown-body.open {\n  display: block;\n}\n\n.dropdown-item {\n  padding: 10px;\n}\n\n.dropdown-item:hover {\n  cursor: pointer;\n}\n\n.dropdown-item-dot {\n  opacity: 0;\n  color: #91A5BE;\n  transition: all .2s ease-in-out;\n}\n\n.dropdown-item-dot.selected {\n  opacity: 1;\n}\n\n.icon {\n  font-size: 13px;\n  color: #91A5BE;\n  transform: rotate(0deg);\n  transition: all .2s ease-in-out;\n}\n\n.icon.open {\n  transform: rotate(90deg);\n}\n\n.contr-margin{\n  margin-left: -2rem;\n}\n\n.input-amount{\n  font-size:1.3em; padding:.5em;\n}\n\n#hide {\n  position: absolute;\n  opacity: 0;\n  z-index: -100;\n  white-space: pre;\n}\n\n.machine-width{\n  min-width: 25px;\n  padding: 0;\n}\n\n.left-side-alt{\n  height: auto !important;\n}\n\n.left-side{\n  height: 100vh;\n  background: rgba(19, 59, 105, 0.08);\n}\n\n.add-beneficiary-text{\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 20px;\n  color: #17477E;\n}\n\n.add-beneficiary-button{\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 8px 24px;\n  gap: 4px;\n  border: 1px solid #17477E;\n  border-radius: 60px;\n}\n\n.left-side-image-position{\n  position: absolute;\n  right: 0;\n  width: 15rem;\n  bottom: 0;\n  z-index: 1;\n}\n\n.get-started-date{\n  padding: 5px 8px !important;\n  align-items: center !important;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n  color: #696969;\n}\n\n.left-side-text-position{\n  margin: 7rem 4rem;\n  z-index: 99;\n}\n\n.left-side-heading{\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 56px;\n  line-height: 84px;\n  color: #133B69;\n}\n\n.left-side-sub-heading{\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 30px;\n  color: #696969;\n}\n\n.right-side{\n  margin: 5rem 7rem;\n}\n\n.upload-box{\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 10px 21px 10px 8px;\n  gap: 8px;\n  width: 284px;\n  height: 52px;\n  border: 0.6px solid #434343;\n  border-radius: 8px;\n  flex: none;\n  flex-grow: 0;\n}\n\n.avatar-upload .avatar-edit input {\n  display: none;\n}\n.avatar-upload .avatar-edit input + label {\n  display: inline-block;\n  /* height: 65px;  */\n  margin-bottom: 0;\n  border-radius: 100%;\n  cursor: pointer;\n  font-weight: normal;\n  transition: all .2s ease-in-out;\n}\n\n.avatar-upload .avatar-edit input + label::before {\n  content: url('../assets/cloud-arrow-up.svg');\n  margin-right: 1rem;\n  margin-top: 5px;\n\n}\n\n.avatar-upload .avatar-edit input + label:after {\n  content: 'Click to upload';\n  color: #757575;\n}\n\n\n.right-side-heading{\n  /* width: 336px; */\n  text-align: center;\n  height: 30px;\n  margin: 0rem 10rem;\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 30px;\n  color: #434343;\n}\n\n.side-heading{\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 32px;\n  line-height: 48px;\n  color: #133B69;\n}\n\n.side-heading-sub{\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n  color: #696969;\n}\n\n.get-started-text-label{\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 24px;\n  color: #434343;\n}\n\n.get-started-border{\n  border: 0.6px solid #434343;\n  border-radius: 8px;\n  width: 286px;\n}\n.get-started-input-choice{\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  padding: 10px 72px 10px 8px;\n  gap: 8px;\n  width: 180px;\n  height: 40px;\n  border: 0.6px solid #434343;\n  border-radius: 8px;\n}\n\n.get-started-input-alt-2{\n  width: 100% !important;\n}\n\n.get-started-input-alt{\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  padding: 10px 38px 10px 8px;\n  border-top-left-radius: 8.6px;\n  border-bottom-left-radius: 8.6px;\n  border: solid 0.6px #434343;\n  border-right: none;\n  gap: 8px;\n  width: 20px;\n  height: 40px;\n  font-size: 12px;\n}\n\n.amount-currency{\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 40px;\n  line-height: 60px;\n  color: #1E1E1E;\n}\n\n.get-started-amount-card{\n  height: 152px;\n  background: #B2C2D4;\n}\n\n.get-started-input-box-alt-1{\n  width: 100% !important;\n}\n\n.get-started-input-box-alt{\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  padding: 10px 38px 10px 8px;\n  border-top-right-radius: 8.6px;\n  border-bottom-right-radius: 8.6px;\n  border: solid 0.6px #434343;\n  border-left: none;\n  gap: 8px;\n  width: 240px;\n  height: 40px;\n  font-size: 12px;\n}\n\n.get-started-input{\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  padding: 10px 72px 10px 8px;\n  gap: 8px;\n  width: 286px;\n  height: 40px;\n  border: 0.6px solid #434343;\n  border-radius: 8px;\n}\n\n.get-started-input::placeholder{\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n  color: #696969;\n}\n\n.prefix-text{\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n  color: #696969;\n  margin: auto;\n}\n\n.phone-number-instruction{\n  width: 284px;\n  height: 40px;\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n  color: #156CE1;\n}\n\n.retirement-button-text{\n  font-style: normal;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 20px;\n  color: #17477E;\n  display: inline-flex;\n}\n\n.bi-arrow-right-margin{\n  margin: 3px 5px;\n}\n\n.calculator-scroll-text{\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 24px;\n  color: #133B69;\n}\n\n.calculator-scroll-text-alt{\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 24px;\n  color: #8E8E8E;\n\n}\n\n.calculator-scroll-button-alt{\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  gap: 8px;\n  width: 204px;\n  height: 40px;\n  background: rgba(209, 218, 229, 0.5);\n  border: 2px solid #D2D2D2;\n  border-radius: 24px;\n}\n\n.calculator-scroll-button{\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  gap: 8px;\n  width: 206px;\n  height: 40px;\n  background: rgba(209, 218, 229, 0.5);\n  border: 2px solid #133B69;\n  border-radius: 24px;\n\n}\n\n.currency-amount-text{\n  background: transparent;\n  font-size: 40px;\n  width: 15rem;\n  font-style: normal;\n  font-weight: 600;\n}\n\n.currency-amount-tip{\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 500;\n  font-size: 8px;\n  line-height: 20px;\n  color: #F24A4A;\n  margin-left: 1rem;\n}\n\n.frequency-border{\n  border: 0.6px solid #434343;\n  border-radius: 8px;\n  flex: none;\n  order: 1;\n  align-self: stretch;\n  flex-grow: 0;\n}\n\n.currency-amount-text::placeholder {\n  font-size: 40px;\n  width: 15rem;\n  font-style: normal;\n  font-weight: 600;\n  color: #191919\n}\n\n\n.currency-position{\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n}\n\n.retirement-button{\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 16px 24px;\n  gap: 4px;\n  /* width: 233px; */\n  height: 56px;\n  left: 98.12px;\n  top: 928px;\n  border: 1px solid #17477E;\n  border-radius: 8px;\n}\n\n.choose-gender-img{\n  /* width: 7rem; */\n  height: 2.5rem;\n}\n\n.network-width{\n  width: 80px;\n  height: 80px;\n}\n\n.network-width-alt{\n  height: 50px;\n}\n\n.network-width-alt-mobile{\n  height: 35px;\n}\n\n.get-started-button-alt{\n  width: 350px !important;\n}\n\n.get-started-back-position{\n  margin: 1rem 4rem;\n}\n\n.get-started-button{\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 16px 32px;\n  gap: 10px;\n  width: 432px;\n  height: 56px;\n  background: #133B69;\n  border-radius: 8px;\n}\n\n.get-started-button-altered{\n  width: fit-content !important;\n}\n\n.get-started-button-text{\n  font-style: normal;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 24px;\n  color: #FFFFFF;\n}\n\n.network-img-border{\n  border: 1px solid #133B69;\n  border-radius: 8px;\n}\n\ndiv.scrollmenu {\n  overflow: auto;\n  white-space: nowrap;\n}\n\ndiv.scrollmenu button {\n  display: inline-block;\n  text-align: center;\n  text-decoration: none;\n}\n\n/* Chrome, Safari, Edge, Opera */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=number] {\n  -moz-appearance: textfield;\n}\n\n.pinBox {\n  --width: 330px;\n  --height: 76px;\n  --spacing: 56px;\n  display: inline-block;\n  position: relative;\n  width: 235px;\n  height: var(--height);\n  background-image: url('../assets/box_border.png'); \n  background-repeat: space;\n  background-position: initial;\n}\n\n\n.pin-box-mobile {\n  --width: 22rem;\n  --height: 76px;\n  --spacing: 66px;\n  display: inline-block;\n  position: relative;\n  height: var(--height);\n  background-image: url('../assets/box_border.png'); \n  background-repeat: space;\n  background-position: initial;\n}\n\n.pin-entry-mobile {\n  position: absolute;\n  padding-left: 30px;\n  font-family: 'Poppins';\n  font-size: 33px;\n  height: 75px;\n  letter-spacing: 82px;\n  background-color: transparent;\n  border: 0;\n  outline: none;\n  clip: rect(0px, calc(var(--width) - 21px), var(--height), 0px);\n}\n\n.pinEntry {\n  position: absolute;\n  padding-left: 25px;\n  font-family: 'Poppins';\n  font-size: var(--spacing);\n  height: var(--height);\n  letter-spacing: var(--spacing);\n  background-color: transparent;\n  border: 0;\n  outline: none;\n  clip: rect(0px, calc(var(--width) - 21px), var(--height), 0px);\n}\n\n#partitioned {\n  padding-left: 15px;\n  letter-spacing: 42px;\n  border: 0;\n  \n  background-image: linear-gradient(to left, black 70%, rgba(255, 255, 255, 0) 0%);\n  background-position: bottom;\n  background-size: 50px 1px;\n  background-repeat: repeat-x;\n  background-position-x: 40px;\n  width: 195px;\n  outline : none;\n}\n\n.pin-code-1{ \n  padding: 0; \n  /* margin: 0 auto;  */\n  /* display: flex; */\n  justify-content:center;\n  \n} \n \n.pin-code-1 input { \n  border: none;\n  text-align: center;\n  width: 48px;\n  height: 48px;\n  font-size: 24px;\n  margin-right: 35px;\n  width: 48px;\n  height: 48px;\n  border: 0.6px solid #696969;\n  border-radius: 8px;\n  font-size: 20px;\n  line-height: 30px;\n  color: #696969;\n} \n\n.pin-code-1 input:focus { \n  border: 1px solid #573D8B;\n  outline:none;\n} \n\n.pin-code{ \n  padding: 0; \n  /* margin: 0 auto;  */\n  /* display: flex; */\n  justify-content:center;\n  \n} \n \n.pin-code input { \n  border: none;\n  text-align: center;\n  width: 48px;\n  height: 48px;\n  font-size: 24px;\n  margin-right: 35px;\n  width: 48px;\n  height: 48px;\n  border: 0.6px solid #696969;\n  border-radius: 8px;\n  font-size: 20px;\n  line-height: 30px;\n  color: #696969;\n} \n\n.pin-code input:focus { \n  border: 1px solid #573D8B;\n  outline:none;\n} \n\n\n.pincode::-webkit-outer-spin-button,\n.pincode::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\n.pdf-layout-alt{\n  height: 40vh;\n  width: 55rem;\n  margin: 2rem auto;\n}\n\n.all-page-container {\n  height: 100%;\n  max-height: 500px;\n  overflow: auto;\n}\n\n.react-pdf__Page {\n  margin-top: 10px;\n}\n.react-pdf__Page__textContent {\n  border: 1px solid darkgrey;\n  box-shadow: 5px 5px 5px 1px #ccc;\n  border-radius: 5px;\n}\n\n.react-pdf__Page__annotations{\n  width: 75% !important;\n  height: 0px !important;\n}\n\n.coming-soon-container{\n  max-width: 100%;\n}\n\n.coming-soon-container-alt{\n  height: 100vh !important;\n  width: 100% !important;\n}\n\n.coming-soon-container img {\n  max-width: 100%;\n  height: auto;\n}\n\n.react-pdf__Page__annotations.annotationLayer {\n  padding: 20px;\n}\n\n.react-pdf__Page__canvas {\n  margin: 0 auto;\n  display: block;\n  user-select: none;\n  /* width: 100% !important; */\n  height: 841px;\n}\n\n.pdf-layout{\n  border: solid 2px;\n  width: 49rem;\n  margin: 2rem auto;\n  overflow: auto;\n}\n\n.pdf-layout-mobile{\n  border: solid 2px;\n  height: 65vh;\n  overflow: auto;\n  margin: 2rem auto;\n}\n\n.pdf-document {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.textLayer{\n  display: none !important;\n}\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=number] {\n  -moz-appearance: textfield;\n}\n\n\n.depositTab{\n  padding: 16px;\n}\n\n.rgbaBG{\n  background-color: rgba(205, 230, 223, 0.3);\n}\n\n.rgbaBG2{\n  background-color: rgba(242, 242, 242, 0.5);\n}\n\n.rgbaBG3{\n  background-color: rgba(253, 244, 207, 0.4);\n}\n\nhtml {\n  overflow: scroll;\n  overflow-x: hidden;\n}\n::-webkit-scrollbar {\n  width: 0;  /* Remove scrollbar space */\n  background: transparent;  /* Optional: just make scrollbar invisible */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
